import { Mode as CartMode } from '../block/Cart.jsx';
import { ButtonType as CookiePolicyButtonType } from '../block/CookiePolicy.jsx';
import { ButtonType as InventoryCTAButtonType } from '../block/InventoryCTA.jsx';
import Kit from './Kit.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import PrivateView from '../common/PrivateView.jsx';
import { Mode as PurchasePopupMode } from '../block/PurchasePopup.jsx';
import Token from '../common/Token.jsx';

const Defaults = {
    cellDesign: (config, blockConfig, context) => {
        let cellKey = 'cell';
        let container = 'block';
        let contentConfig, defaultConfig;
        switch (context) {
            case Kit.Context.Cell.Artist.Grid:
                container = 'grid';
                defaultConfig = Defaults.Block[Name.Block.Artist.List].GridCell;
                break;
            case Kit.Context.Cell.Blog:
                cellKey = 'blogCell';
                defaultConfig = Defaults.Block[Name.Block.Blog.List].Cell;
                break;
            case Kit.Context.Cell.Exhibition.Grid:
                defaultConfig = Defaults.Block[Name.Block.Show.List.Grid].Cell;
                break;
            case Kit.Context.Cell.Exhibition.Parallax:
                defaultConfig = Defaults.Block[Name.Block.Show.List.Parallax].Cell;
                break;
            case Kit.Context.Cell.Inventory.Grid:
                container = 'grid';
                defaultConfig = Defaults.Block[Name.Block.Inventory.ListV4].GridCell;
                break;
            case Kit.Context.Cell.Inventory.Waterfall:
                container = 'waterfall';
                defaultConfig = Defaults.Block[Name.Block.Inventory.ListV4].WaterfallCell;
                break;
            case Kit.Context.Cell.RecentlyViewed:
                defaultConfig = Defaults.Block[Name.Block.Inventory.RecentlyViewed.List].Cell;
                break;
            case PageType.Content.Presentation.InventoryCell.Grid:
                container = 'grid';
                const theme = Defaults.Block[Kit.Type.Presentation].getTheme();
                defaultConfig = Defaults.Block[Kit.Type.Presentation][Kit.Type.Cell][Name.Block.Inventory.ListV4].GridCellConstructor({ artist: config?.artist == undefined, availability: true, dimensions: true, medium: true, price: true }, theme);
                break;
        }
        // Use cell design kit by default
        contentConfig = contentConfig || Kit.designKit(config, context);
        if (blockConfig && blockConfig[container] && !blockConfig[container].useCellKit && blockConfig[container][cellKey] && blockConfig[container][cellKey].desktop && blockConfig[container][cellKey].desktop.blocks && blockConfig[container][cellKey].desktop.blocks.length > 0) {
            // Not using cell design kit and custom design has blocks => Use custom design
            contentConfig = blockConfig[container][cellKey];
        } else if (!contentConfig || !contentConfig.desktop || !contentConfig.desktop.blocks || contentConfig.desktop.blocks.length == 0) {
            // Empty cell design kit => Use default design
            contentConfig = defaultConfig;
        }
        return contentConfig;
    },

    inputText: () => Layout.wrapTextForEditor({ text: `{${Token.InputText}}`, token: Token.InputText }),

    subscribeForm: (formType) => {
        const Form = Name.Block.SubscribeForm.baseFromContext(formType)
        return {
            "desktop": {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "columnCount": "2",
                                "flexDirection-col1": "row",
                                "alignment-col1": "tl",
                                "flexDirection-col2": "row",
                                "alignment-col2": "tl",
                                "paddingRight-col1": {
                                    "unit": "px",
                                    "value": "5"
                                },
                                "paddingLeft-col2": {
                                    "unit": "px",
                                    "value": "5"
                                }
                            },
                            "layout": {
                                "textAlign": "center",
                                "backgroundPosition": "mc",
                                "backgroundSize": "contain",
                                "backgroundRepeatX": false,
                                "backgroundRepeatY": false
                            }
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "block": {
                                            "type": "Name",
                                            "borderRadius": {
                                                "value": "2",
                                                "unit": "px"
                                            }
                                        },
                                        "layout": {
                                            "marginBottom": {
                                                "value": "10",
                                                "unit": "px"
                                            },
                                            "paddingLeft": {
                                                "value": "15",
                                                "unit": "px"
                                            },
                                            "paddingRight": {
                                                "value": "15",
                                                "unit": "px"
                                            },
                                            "height": {
                                                "value": "40",
                                                "unit": "px"
                                            },
                                            "width": {
                                                "value": "100",
                                                "unit": "%"
                                            },
                                            "alignment": "center"
                                        }
                                    },
                                    "id": `${Form.Input.Name}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Form.Input.Name
                                    }
                                }
                            ],
                            [
                                {
                                    "config": {
                                        "block": {
                                            "type": "Email",
                                            "borderRadius": {
                                                "value": "2",
                                                "unit": "px"
                                            }
                                        },
                                        "layout": {
                                            "marginBottom": {
                                                "value": "10",
                                                "unit": "px"
                                            },
                                            "paddingLeft": {
                                                "value": "15",
                                                "unit": "px"
                                            },
                                            "paddingRight": {
                                                "value": "15",
                                                "unit": "px"
                                            },
                                            "height": {
                                                "value": "40",
                                                "unit": "px"
                                            },
                                            "width": {
                                                "value": "100",
                                                "unit": "%"
                                            },
                                            "alignment": "center"
                                        }
                                    },
                                    "id": `${Form.Input.Email}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Form.Input.Email
                                    }
                                }
                            ]
                        ]
                    },
                    {
                        "config": {
                            "block": {
                                "buttonDesign": Kit.Context.Button.Primary,
                                "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'SUBSCRIBE' })
                            },
                            "hover": {},
                            "layout": {
                                "paddingLeft": {
                                    "value": "10",
                                    "unit": "px"
                                },
                                "paddingRight": {
                                    "value": "10",
                                    "unit": "px"
                                },
                                "height": {
                                    "value": "40",
                                    "unit": "px"
                                },
                                "width": {
                                    "value": "100",
                                    "unit": "%"
                                },
                                "alignment": "center"
                            }
                        },
                        "id": `${Form.SubmitButtonV2}-${new Date().getTime()}`,
                        "type": {
                            "value": Form.SubmitButtonV2
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "design": Defaults.Block.ErrorMessage()
                            },
                            "layout": {
                                "paddingTop": {
                                    "value": "10",
                                    "unit": "px"
                                },
                                "alignment": "center"
                            }
                        },
                        "id": `${Form.ErrorMessage}-${new Date().getTime()}`,
                        "type": {
                            "value": Form.ErrorMessage
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "design": Layout.wrapTextForEditor({ text: 'Thank you for subscribing to our mailing list!' })
                            },
                            "layout": {
                                "paddingTop": {
                                    "value": "10",
                                    "unit": "px"
                                },
                                "alignment": "center"
                            }
                        },
                        "id": `${Form.SuccessMessage}-${new Date().getTime()}`,
                        "type": {
                            "value": Form.SuccessMessage
                        }
                    }
                ],
                "page": {
                    "config": {},
                    "type": formType,
                    "display": formType == PageType.Form.FooterSubscribe ? 'Footer Subscribe Form' : 'Subscribe Form',
                    "id": "pageSettings"
                }
            }
        };
    },

    Block: {
        ErrorMessage: () => Layout.wrapTextForEditor({ text: `{${Token.ErrorMessage}}`, textExtras: `style="color:rgba(255,0,0,1);"`, token: Token.ErrorMessage }),
        SuccessMessage: () => Layout.wrapTextForEditor({ text: 'Thank you for your submission!' }),

        [Name.Block.Artist.Cell.Text]: (style, alignment) => Layout.wrapTextForEditor({ tagExtras: alignment ? `style="text-align:${alignment};"` : undefined, text: `{${Token.ArtistName}}`, textExtras: style ? `style="${style}"` : undefined, token: Token.ArtistName }),
        [Name.Block.Artist.NameV1]: {
            Design: () => Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header1, ...Defaults.Block[Name.Block.Artist.NameV1].EditorProps }),
            EditorProps: { text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName }
        },
        [Name.Block.Artist.NameV2]: `<span token="${Token.ArtistName}">{${Token.ArtistName}("before":"","after":"")}</span>`,
        [Name.Block.Blog.Cell.Text]: `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.Title}}`, token: Token.Title })}${Layout.wrapTextForEditor({ text: `{${Token.Published}}`, token: Token.Published })}${Layout.wrapTextForEditor({ text: `{${Token.Excerpt}}`, token: Token.Excerpt })}`,
        [Name.Block.Blog.Meta]: () => Layout.wrapTextForEditor({ text: `{${Token.Published}}`, token: Token.Published }),
        [Name.Block.Blog.TitleV1]: {
            Design: () => Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header1, text: `{${Token.Title}}`, token: Token.Title }),
            Display: `<span token="${Token.Title}">{${Token.Title}}</span>`
        },
        [Name.Block.Blog.TitleV2]: {
            Design: () => Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header1, ...Defaults.Block[Name.Block.Blog.TitleV2].EditorProps }),
            EditorProps: { text: `{${Token.Title}}`, token: Token.Title }
        },
        [Name.Block.ButtonV2]: ({ displayText, fontSize, textAlign, textColor }) => Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:${textAlign || 'center'};"`, text: displayText == undefined ? 'BUTTON' : displayText, textExtras: `style="${textColor ? `color:${textColor};` : ''}${fontSize ? `font-size:${fontSize};"` : '"'}` }),
        [Name.Block.Cart.LineItem.List]: {
            Cell: {
                InventoryDesign: (config, canEdit) => {
                    const bodyTextColor = (config.colors && config.colors.bodyText) || '';
                    const blockConfig = {
                        "desktop": {
                            "blocks": [
                                {
                                    "config": {
                                        "block": {
                                            "alignment-col1": "tl",
                                            "alignment-col2": "tl",
                                            "alignment-col3": "tl",
                                            "alignment-col4": "tr",
                                            "columnCount": "4",
                                            "flexDirection-col1": "row",
                                            "flexDirection-col2": "column",
                                            "flexDirection-col3": "column",
                                            "flexDirection-col4": "row",
                                            "minWidth-col1": {
                                                "unit": "%",
                                                "value": "40"
                                            },
                                            "minWidth-col2": {
                                                "unit": "%",
                                                "value": "30"
                                            },
                                            "paddingLeft-col1": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingLeft-col2": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingLeft-col3": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingLeft-col4": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingRight-col1": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingRight-col2": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingRight-col3": {
                                                "unit": "px",
                                                "value": "10"
                                            }
                                        },
                                        "layout": {
                                            "minWidth": {
                                                "unit": "%",
                                                "value": "100"
                                            },
                                            "textAlign": "center"
                                        }
                                    },
                                    "dataType": "layout",
                                    "id": `${Name.Block.Columns}-inventoryLineItem-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.Columns
                                    },
                                    "blocks": [
                                        [
                                            {
                                                "config": {
                                                    "layout": {}
                                                },
                                                "id": `${Name.Block.Inventory.Cell.Image}-${new Date().getTime()}`,
                                                "type": {
                                                    "value": Name.Block.Inventory.Cell.Image
                                                }
                                            }
                                        ],
                                        [
                                            {
                                                "config": {
                                                    "block": {
                                                        "design": Defaults.Block[Name.Block.Cart.LineItem.List].Cell.InventoryLineItemText(config)
                                                    },
                                                    "layout": {}
                                                },
                                                "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                                                "type": {
                                                    "value": Name.Block.Inventory.Cell.Text
                                                }
                                            }
                                        ],
                                        [
                                            {
                                                "config": {
                                                    "block": {
                                                        "placeholder": Layout.wrapTextForEditor({ text: 'Qty' }),
                                                        "design": Defaults.inputText(),
                                                        "borderRadius": {
                                                            "value": "2",
                                                            "unit": "px"
                                                        }
                                                    },
                                                    "layout": {
                                                        "marginBottom": {
                                                            "value": "10",
                                                            "unit": "px"
                                                        },
                                                        "paddingLeft": {
                                                            "value": "10",
                                                            "unit": "px"
                                                        },
                                                        "paddingRight": {
                                                            "value": "10",
                                                            "unit": "px"
                                                        },
                                                        "height": {
                                                            "value": "40",
                                                            "unit": "px"
                                                        },
                                                        "width": {
                                                            "value": "100",
                                                            "unit": "%"
                                                        },
                                                        "alignment": "center"
                                                    }
                                                },
                                                "id": `${Name.Block.Cart.LineItem.Cell.InventoryLineItemQuantityInput}-${new Date().getTime()}`,
                                                "type": {
                                                    "value": Name.Block.Cart.LineItem.Cell.InventoryLineItemQuantityInput
                                                }
                                            }
                                        ],
                                        [
                                            {
                                                "config": {
                                                    "block": {
                                                        "design": Layout.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Price}("before":"","after":"")}`, token: Token.Price })
                                                    },
                                                    "layout": {}
                                                },
                                                "id": `${Name.Block.Inventory.Cell.Text}-price-${new Date().getTime()}`,
                                                "type": {
                                                    "value": Name.Block.Inventory.Cell.Text
                                                }
                                            }
                                        ]
                                    ]
                                }
                            ],
                            "page": {
                                "config": {
                                    "block": {},
                                    "layout": {}
                                },
                                "type": PageType.Content.Cart.InventoryLineItemCell,
                                "display": "Cart Inventory Line Item Cell Template",
                                "id": "pageSettings"
                            }
                        }
                    }
                    if (canEdit != false) {
                        blockConfig.desktop.blocks[0].blocks[0].splice(0, 0, {
                            "config": {
                                "block": {
                                    "color": bodyTextColor,
                                    "fontSize": {
                                        "unit": "px",
                                        "value": "16"
                                    }
                                },
                                "layout": {
                                    "alignment": "center",
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "30"
                                    }
                                }
                            },
                            "id": `${Name.Block.Cart.RemoveButton}-inventoryLineItem-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.RemoveButton
                            }
                        });
                    }
                    return blockConfig;
                },
                InventoryLineItemText: () => `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Medium}("before":"","after":"")}`, token: Token.Medium })}${Layout.wrapTextForEditor({ text: `{${Token.Dimensions}("before":"","after":"")}`, token: Token.Dimensions })}`,
                PromoCodeDesign: (config, canEdit) => {
                    const bodyTextColor = (config.colors && config.colors.bodyText) || '';
                    const blockConfig = {
                        "desktop": {
                            "blocks": [
                                {
                                    "config": {
                                        "block": {
                                            "alignment-col1": "tc",
                                            "alignment-col2": "tl",
                                            "alignment-col3": "tr",
                                            "columnCount": "3",
                                            "flexDirection-col1": "column",
                                            "flexDirection-col2": "column",
                                            "flexDirection-col3": "column",
                                            "minWidth-col1": {
                                                "unit": "%",
                                                "value": "8.33"
                                            },
                                            "minWidth-col2": {
                                                "unit": "%",
                                                "value": "72.22"
                                            },
                                            "minWidth-col3": {
                                                "unit": "%",
                                                "value": "19.45"
                                            },
                                            "paddingLeft-col1": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingLeft-col2": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingLeft-col3": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingRight-col1": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "paddingRight-col2": {
                                                "unit": "px",
                                                "value": "10"
                                            }
                                        },
                                        "layout": {
                                            "minWidth": {
                                                "unit": "%",
                                                "value": "100"
                                            },
                                            "textAlign": "center"
                                        }
                                    },
                                    "dataType": "layout",
                                    "id": `${Name.Block.Columns}-promoCodeLineItem-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.Columns
                                    },
                                    "blocks": [
                                        [],
                                        [
                                            {
                                                "config": {
                                                    "block": {
                                                        "design": Defaults.Block[Name.Block.Cart.LineItem.List].Cell.PromoCodeLineItemText
                                                    },
                                                    "layout": {}
                                                },
                                                "id": `${Name.Block.Cart.LineItem.Cell.PromoCodeLineItemText}-${new Date().getTime()}`,
                                                "type": {
                                                    "value": Name.Block.Cart.LineItem.Cell.PromoCodeLineItemText
                                                }
                                            }
                                        ],
                                        [
                                            {
                                                "config": {
                                                    "block": {
                                                        "design": Layout.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Discount}("before":"","after":"")}`, token: Token.Discount })
                                                    },
                                                    "layout": {}
                                                },
                                                "id": `${Name.Block.Cart.LineItem.Cell.PromoCodeLineItemText}-discount-${new Date().getTime()}`,
                                                "type": {
                                                    "value": Name.Block.Cart.LineItem.Cell.PromoCodeLineItemText
                                                }
                                            }
                                        ]
                                    ]
                                }
                            ],
                            "page": {
                                "config": {
                                    "block": {},
                                    "layout": {}
                                },
                                "type": PageType.Content.Cart.PromoCodeLineItemCell,
                                "display": "Cart Promo Code Line Item Cell Template",
                                "id": "pageSettings"
                            }
                        }
                    }
                    if (canEdit != false) {
                        blockConfig.desktop.blocks[0].blocks[0].push({
                            "config": {
                                "block": {
                                    "color": bodyTextColor,
                                    "fontSize": {
                                        "unit": "px",
                                        "value": "16"
                                    }
                                },
                                "layout": {
                                    "alignment": "center",
                                    "marginTop": {
                                        "unit": "px",
                                        "value": "4"
                                    }
                                }
                            },
                            "id": `${Name.Block.Cart.RemoveButton}-promoCodeLineItem-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.RemoveButton
                            }
                        });
                    }
                    return blockConfig;
                },
                PromoCodeLineItemText: `${Layout.wrapTextForEditor({ text: `{${Token.PromoCode}("before":"Promo Code ","after":"")}`, token: Token.PromoCode })}${Layout.wrapTextForEditor({ text: `{${Token.Description}("before":"","after":"")}`, token: Token.Description })}`
            }
        },
        [Name.Block.Cart.StripeElements]: {
            "config": {
                "block": {
                    "gridColumnSpacing": {
                        "value": "20",
                        "unit": "px"
                    },
                    "gridRowSpacing": {
                        "value": "10",
                        "unit": "px"
                    }
                },
                "label": {
                    "visible": false,
                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Paragraph, text: `{${Token.LabelText}}`, token: Token.LabelText }),
                    "marginBottom": {
                        "value": "5",
                        "unit": "px"
                    }
                },
                "input": {
                    "placeholder": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Paragraph, text: `{${Token.PlaceholderText}}`, textExtras: `style="line-height:40px;"`, token: Token.PlaceholderText }),
                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Paragraph, text: `{${Token.InputText}}`, textExtras: `style="line-height:40px;"`, token: Token.InputText }),
                    "borderRadius": {
                        "value": "2",
                        "unit": "px"
                    },
                    "paddingBottom": {
                        "value": "0",
                        "unit": "px"
                    },
                    "paddingLeft": {
                        "value": "10",
                        "unit": "px"
                    },
                    "paddingRight": {
                        "value": "10",
                        "unit": "px"
                    },
                    "paddingTop": {
                        "value": "0",
                        "unit": "px"
                    }
                },
                "tab": {
                    "paddingBottom": {
                        "value": "10",
                        "unit": "px"
                    },
                    "paddingLeft": {
                        "value": "15",
                        "unit": "px"
                    },
                    "paddingRight": {
                        "value": "15",
                        "unit": "px"
                    },
                    "paddingTop": {
                        "value": "10",
                        "unit": "px"
                    },
                    "borderRadius": {
                        "value": "2",
                        "unit": "px"
                    },
                    "iconSpacing": {
                        "value": "4",
                        "unit": "px"
                    },
                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Paragraph, text: `{${Token.LabelText}}`, token: Token.LabelText }),
                    "designSelected": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Paragraph, text: `{${Token.LabelText}}`, token: Token.LabelText }),
                },
                "layout": {
                    "minWidth": {
                        "value": "100",
                        "unit": "%"
                    },
                    "alignment": "center"
                }
            },
            "id": `${Name.Block.Cart.StripeElements}-${new Date().getTime()}`,
            "type": {
                "value": Name.Block.Cart.StripeElements
            }
        },
        [Name.Block.Contact.Address]: `${Layout.wrapTextForEditor({ text: `{${Token.Address.Line1}("before":"","after":"")}`, token: Token.Address.Line1 })}${Layout.wrapTextForEditor({ text: `{${Token.Address.Line2}("before":"","after":"")}`, token: Token.Address.Line2 })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Group}("components":["{${Token.Address.City}(*'before*':*'*',*'after*':*'*')}","{${Token.Address.State}(*'before*':*'*',*'after*':*'*')}"],"separator":", ")}`, token: Token.Group, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Address.Zip}("before":" ","after":"")}`, token: Token.Address.Zip, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Address.Country}("before":"","after":"")}`, token: Token.Address.Country })}${Layout.wrapTextForEditor({ text: `{${Token.Phone}("before":"","after":"")}`, token: Token.Phone })}`,
        [Name.Block.Contact.HoursV2]: Layout.wrapTextForEditor({ text: `{${Token.Hours}}`, token: Token.Hours }),
        [Name.Block.Footer.QuickLinksV2]: (color) => Layout.wrapTextForEditor({ text: `{${Token.ItemTitle}}`, textExtras: color ? `style="color:${color};"` : undefined, token: Token.ItemTitle }),
        [Name.Block.Header.MenuItemsV2]: (color) => Layout.wrapTextForEditor({ text: `{${Token.ItemTitle}}`, textExtras: color ? `style="color:${color};"` : undefined, token: Token.ItemTitle }),
        [Name.Block.Header.MobileToggle]: () => Layout.wrapTextForEditor({ text: `{${Token.ItemTitle}}`, token: Token.ItemTitle }),
        [Name.Block.Inventory.Button.InquireV1]: 'Inquire',
        [Name.Block.Inventory.Button.OfferV1]: 'Make an Offer',
        [Name.Block.Inventory.Button.PurchaseV1]: 'Purchase',
        [Name.Block.Inventory.Cell.Text]: `${Layout.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName })}<p class="p" style="text-align:center;">${Layout.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: `{${Token.Medium}("before":"","after":"")}`, token: Token.Medium })}${Layout.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: `{${Token.Dimensions}("before":"","after":"")}`, token: Token.Dimensions })}${Layout.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: `{${Token.Price}("showIfSold":"true","before":"","after":"")}`, token: Token.Price })}`,
        [Name.Block.Inventory.ControlsV2]: ({ color, display }) => Layout.wrapTextForEditor({ text: display, textExtras: color ? `style="color:${color};"` : undefined }),
        [Name.Block.Inventory.Artist.NameV1]: {
            Design: () => Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header2, ...Defaults.Block[Name.Block.Inventory.Artist.NameV1].EditorProps }),
            EditorProps: { text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName }
        },
        [Name.Block.Inventory.RecentlyViewed.Cell.Text]: () => Defaults.Block[Name.Block.Inventory.Cell.Text],
        [Name.Block.Inventory.Text]: () => `${Layout.wrapTextForEditor({ text: `{${Token.ArtistName}("before":"","after":"")}`, textExtras: `style="font-size:14px;letter-spacing:1px;text-transform:uppercase;"`, token: Token.ArtistName })}<p class="p">&nbsp;</p><p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-size:28px;font-style:italic;"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;font-size:28px;"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;font-size:28px;"`, token: Token.Date, wrapWithTag: false })}</p><p class="p">&nbsp;</p>${Layout.wrapTextForEditor({ text: `{${Token.Group}("components":["{${Token.Medium}(*'before*':*'*',*'after*':*'*')}","{${Token.Dimensions}(*'before*':*'*',*'after*':*'*')}"],"separator":", ")}`, textExtras: `style="font-size:14px;"`, token: Token.Group })}<p class="p">&nbsp;</p><hr><p class="p">&nbsp;</p>${Layout.wrapTextForEditor({ text: `{${Token.Price}("showIfSold":"true","before":"","after":"")}`, textExtras: `style="font-size:18px;"`, token: Token.Price })}`,
        [Name.Block.PageTitleV1]: {
            Design: () => Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header1, ...Defaults.Block[Name.Block.PageTitleV1].EditorProps }),
            EditorProps: { text: `{${Token.Title}}`, token: Token.Title }
        },
        [Name.Block.PageTitleV2]: `<span token="${Token.Title}">{${Token.Title}}</span>`,
        [Name.Block.Representative.Cell.Text]: () => `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.CompanyName}("before":"","after":"")}`, token: Token.CompanyName })}${Layout.wrapTextForEditor({ text: `{${Token.Address.Line1}("before":"","after":"")}`, token: Token.Address.Line1 })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Group}("components":["{${Token.Address.City}(*'before*':*'*',*'after*':*'*')}","{${Token.Address.State}(*'before*':*'*',*'after*':*'*')}"],"separator":", ","before":"","after":" ")}`, token: Token.Group, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Address.Zip}("before":"","after":"")}`, token: Token.Address.Zip, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Website}("display":"Website")}`, token: Token.Website })}`,
        [Name.Block.SearchResult.Cell.Text.Artist]: () => `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: 'ARTIST', textExtras: `style="display:inline-block;margin:0 0 15px 0;"` })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.ArtistLifespan}("before":" - ","after":"")}`, token: Token.ArtistLifespan, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.ArtistBiography}("before":"","after":"")}`, token: Token.ArtistBiography })}`,
        [Name.Block.SearchResult.Cell.Text.Blog]: () => `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: 'BLOG', textExtras: `style="display:inline-block;margin:0 0 15px 0;"` })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.Title}("before":"","after":"")}`, token: Token.Title })}${Layout.wrapTextForEditor({ text: `{${Token.Published}("before":"","after":"")}`, token: Token.Published })}${Layout.wrapTextForEditor({ text: `{${Token.Excerpt}("before":"","after":"")}`, token: Token.Excerpt })}`,
        [Name.Block.SearchResult.Cell.Text.Inventory]: () => `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: 'INVENTORY', textExtras: `style="display:inline-block;margin:0 0 15px 0;"` })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="font-style:italic;"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Edition}("before":" (","after":")")}`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, token: Token.Date, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Medium}("before":"","after":"")}`, token: Token.Medium })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Dimensions}("before":"","after":"")}`, token: Token.Dimensions, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.AlternateDimensions}("before":" (","after":")")}`, token: Token.AlternateDimensions, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Price}("showIfSold":"true","before":"","after":"")}`, token: Token.Price })}`,
        [Name.Block.SearchResult.Cell.Text.Show]: () => `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: 'EXHIBITION', textExtras: `style="display:inline-block;margin:0 0 15px 0;"` })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.Title}("before":"","after":"")}`, token: Token.Title })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })}${Layout.wrapTextForEditor({ text: `{${Token.Description}("before":"","after":"")}`, token: Token.Description })}`,
        [Name.Block.Show.Cell.Text]: {
            Date: Layout.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date }),
            Title: Layout.wrapTextForEditor({ text: `{${Token.Title}}`, token: Token.Title })
        },
        [Name.Block.Show.Description]: Layout.wrapTextForEditor({ text: `{${Token.Description}("before":"","after":"")}`, token: Token.Description }),
        [Name.Block.Show.TitleV1]: {
            Design: () => Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header1, ...Defaults.Block[Name.Block.Show.TitleV1].EditorProps }),
            EditorProps: { text: `{${Token.Title}("before":"","after":"")}`, token: Token.Title }
        },
        [Name.Block.Show.TitleV2]: `<span token="${Token.Title}">{${Token.Title}("before":"","after":"")}</span>`,
        [Name.Block.SignUpButtonV1]: 'Sign Up',
        [Name.Block.Tabs]: (color) => Layout.wrapTextForEditor({ text: `{${Token.TabTitle}}`, textExtras: `style="${color ? `color:${color};` : ''}font-size:11px;letter-spacing:1.2px;"`, token: Token.TabTitle }),
        [Name.Block.TabsV3]: (color) => Layout.wrapTextForEditor({ text: `{${Token.TabTitle}}`, textExtras: color ? `style="color:${color};"` : undefined, token: Token.TabTitle }),
        [Name.Block.Video]: {
            Height: { value: '315', unit: 'px' },
            Width: { value: '560', unit: 'px' }
        }
    },

    MobileConfig: {
        [PageType.Footer]: (templateConfig) => {
            const _templateConfig = templateConfig || {};
            const _config = {
                "blocks": [],
                "page": {
                    "config": {
                        "block": {},
                        "layout": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "40"
                            },
                            "paddingLeft": {
                                "unit": "px",
                                "value": "20"
                            },
                            "paddingRight": {
                                "unit": "px",
                                "value": "20"
                            },
                            "paddingTop": {
                                "unit": "px",
                                "value": "40"
                            }
                        },
                        "copyright": {
                            "fontSize": (_templateConfig.copyright && _templateConfig.copyright.fontSize) || { "unit": "px", "value": "12" },
                            "letterSpacing": (_templateConfig.copyright && _templateConfig.copyright.letterSpacing) || { "unit": "px", "value": "1" },
                            "textAlign": "center",
                            "textTransform": (_templateConfig.copyright && _templateConfig.copyright.textTransform) || 'capitalize'
                        }
                    },
                    "display": "Footer",
                    "id": "pageSettings",
                    "type": PageType.Footer
                }
            };
            if (_templateConfig.social && _templateConfig.social.visibility != 'hidden') {
                const socialConfig = {
                    "config": {
                        "block": {
                            "columns": "0",
                            "columnSpacing": {
                                "unit": "px",
                                "value": "14"
                            }
                        },
                        "social": _templateConfig.social.platforms.map((d, i) => ({
                            "borderRadius": { "unit": "%", "value": "50" },
                            "containerSize": { "unit": "px", "value": "26" },
                            "fontSize": { "unit": "px", "value": "26" },
                            "id": `social-${i}-${new Date().getTime()}`,
                            "newWindow": true,
                            "platform": d.platform
                        })
                        ),
                        "layout": {
                            "marginBottom": {
                                "unit": "px",
                                "value": "40"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": "Social-default",
                    "type": {
                        "value": "Social"
                    }
                }
                _config.blocks.push(socialConfig);
            }
            if (!_templateConfig.address || (_templateConfig.address && _templateConfig.address.visibility != 'hidden')) {
                const color = (_templateConfig.address && _templateConfig.address.color) || 'inherit';
                const fontSize = (_templateConfig.address && _templateConfig.address.fontSize) || '14px';
                const letterSpacing = (_templateConfig.address && _templateConfig.address.letterSpacing) || '2.2px';
                const textTransform = (_templateConfig.address && _templateConfig.address.textTransform) || 'uppercase';
                const addressConfig = {
                    "config": {
                        "block": {
                            "design": `${Layout.wrapTextForEditor({ text: `{${Token.Address.Line1}("before":"","after":"")}`, textExtras: `style="color:${color};font-size:${fontSize};letter-spacing:${letterSpacing};line-height:30px;text-transform:${textTransform};"`, token: Token.Address.Line1 })}${Layout.wrapTextForEditor({ text: `{${Token.Address.Line2}("before":"","after":"")}`, textExtras: `style="color:${color};font-size:${fontSize};letter-spacing:${letterSpacing};line-height:30px;text-transform:${textTransform};"`, token: Token.Address.Line2 })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Group}("components":["{${Token.Address.City}(*'before*':*'*',*'after*':*'*')}","{${Token.Address.State}(*'before*':*'*',*'after*':*'*')}"],"separator":", ")}`, textExtras: `style="color:${color};font-size:${fontSize};letter-spacing:${letterSpacing};line-height:30px;text-transform:${textTransform};"`, token: Token.Group, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Address.Zip}("before":" ","after":"")}`, textExtras: `style="color:${color};font-size:${fontSize};letter-spacing:${letterSpacing};line-height:30px;text-transform:${textTransform};"`, token: Token.Address.Zip, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Address.Country}("before":"","after":"")}`, textExtras: `style="color:${color};font-size:${fontSize};letter-spacing:${letterSpacing};line-height:30px;text-transform:${textTransform};"`, token: Token.Address.Country })}${Layout.wrapTextForEditor({ text: `{${Token.Phone}("before":"","after":"")}`, textExtras: `style="color:${color};font-size:${fontSize};letter-spacing:${letterSpacing};line-height:30px;text-transform:${textTransform};"`, token: Token.Phone })}${Layout.wrapTextForEditor({ text: `{${Token.ContactPageLink}("before":"","after":"")}`, textExtras: `style="color:${color};font-size:${fontSize};letter-spacing:${letterSpacing};line-height:30px;text-transform:${textTransform};"`, token: Token.ContactPageLink })}`
                        },
                        "layout": {
                            "marginBottom": {
                                "unit": "px",
                                "value": "40"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Contact.Address}-default`,
                    "type": {
                        "value": Name.Block.Contact.Address
                    }
                };
                _config.blocks.push(addressConfig);
            }
            return _config;
        },
        [PageType.Header]: (config, isFixed) => {
            const _config = {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "alignment-col1": "ml",
                                "alignment-col2": "mr",
                                "columnCount": "2",
                                "flexDirection-col1": "row",
                                "flexDirection-col2": "row"
                            },
                            "layout": {}
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-default`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "layout": {
                                            "marginLeft": {
                                                "unit": "px",
                                                "value": "20"
                                            },
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "40"
                                            },
                                            "maxWidth": {
                                                "unit": "px"
                                            },
                                            "minHeight": {
                                                "unit": "px",
                                                "value": "40"
                                            },
                                            "textAlign": "left"
                                        }
                                    },
                                    "id": `${Name.Block.Header.LogoV2}-default`,
                                    "type": {
                                        "value": Name.Block.Header.LogoV2
                                    }
                                }
                            ],
                            [
                                {
                                    "config": {
                                        "layout": {
                                            "marginLeft": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "marginRight": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "searchBarDesign": Defaults.Block[Name.Block.Header.SearchBar.Container]
                                        }
                                    },
                                    "id": `${Name.Block.Header.SearchToggleV2}-default`,
                                    "type": {
                                        "value": Name.Block.Header.SearchToggleV2
                                    }
                                },
                                {
                                    "config": {
                                        "layout": {
                                            "marginLeft": {
                                                "unit": "px",
                                                "value": "10"
                                            },
                                            "marginRight": {
                                                "unit": "px",
                                                "value": "20"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.Header.MobileToggle}-default`,
                                    "type": {
                                        "value": Name.Block.Header.MobileToggle
                                    }
                                }
                            ]
                        ]
                    }
                ],
                "page": {
                    "config": {
                        "layout": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "18"
                            },
                            "paddingTop": {
                                "unit": "px",
                                "value": "17"
                            }
                        },
                        "block": {
                            "pageTopOffset": isFixed ? { "unit": "px", "value": "75" } : undefined,
                            "position": isFixed ? "fixed" : "relative"
                        }
                    },
                    "display": "Header",
                    "id": "pageSettings",
                    "type": PageType.Header
                }
            };
            if (config && config.isStripeConnected) {
                const cartConfig = {
                    "config": {
                        "layout": {
                            "marginLeft": {
                                "unit": "px",
                                "value": "10"
                            },
                            "marginRight": {
                                "unit": "px",
                                "value": "10"
                            }
                        }
                    },
                    "id": `${Name.Block.Header.CartLink}-default`,
                    "type": {
                        "value": Name.Block.Header.CartLink
                    }
                };
                _config.blocks[0].blocks[1].splice(1, 0, cartConfig);
            }
            return _config;
        }
    },

    PageConfig: {
        [PageType.Cart]: (config) => {
            return {
                [CartMode.checkout]: {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "columnCount": "2",
                                    "flexDirection-col1": "column",
                                    "alignment-col1": "tr",
                                    "flexDirection-col2": "column",
                                    "alignment-col2": "tl",
                                    "maxWidth-col2": {
                                        "unit": "px",
                                        "value": "520"
                                    },
                                    "paddingLeft-col2": {
                                        "unit": "px",
                                        "value": "30"
                                    },
                                    "paddingRight-col1": {
                                        "unit": "px",
                                        "value": "30"
                                    }
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header2, text: 'Shopping Cart' })
                                            },
                                            "container": {},
                                            "layout": {
                                                "minWidth": {
                                                    "unit": "%",
                                                    "value": "100"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Text}-1-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Text
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "displayText": "<hr>"
                                            },
                                            "container": {},
                                            "layout": {
                                                "minWidth": {
                                                    "unit": "%",
                                                    "value": "100"
                                                },
                                                "paddingBottom": {
                                                    "unit": "px",
                                                    "value": "10"
                                                },
                                                "paddingTop": {
                                                    "unit": "px",
                                                    "value": "10"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Text}-hr1-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Text
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "lineSpacing": {
                                                    "value": "20",
                                                    "unit": "px"
                                                },
                                                "inventoryLineItemCell": Defaults.Block[Name.Block.Cart.LineItem.List].Cell.InventoryDesign(config),
                                                "promoCodeLineItemCell": Defaults.Block[Name.Block.Cart.LineItem.List].Cell.PromoCodeDesign(config)
                                            },
                                            "layout": {
                                                "paddingBottom": {
                                                    "value": "40",
                                                    "unit": "px"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Cart.LineItem.List}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Cart.LineItem.List
                                        }
                                    },
                                    {
                                        "config": {
                                            "layout": {
                                                "design": Defaults.Block[Name.Block.Cart.PromoCode.Container],
                                                "paddingBottom": {
                                                    "value": "20",
                                                    "unit": "px"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Cart.PromoCode.Container}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Cart.PromoCode.Container
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "displayText": "<hr>"
                                            },
                                            "container": {},
                                            "layout": {
                                                "minWidth": {
                                                    "unit": "%",
                                                    "value": "100"
                                                },
                                                "paddingBottom": {
                                                    "unit": "px",
                                                    "value": "10"
                                                },
                                                "paddingTop": {
                                                    "unit": "px",
                                                    "value": "10"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Text}-hr2-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Text
                                        }
                                    },
                                    {
                                        "config": {
                                            "label": {
                                                "design": Layout.wrapTextForEditor({ text: 'Subtotal', textExtras: `style="font-weight:bold;"` }),
                                                "marginRight": {
                                                    "value": "10",
                                                    "unit": "px"
                                                }
                                            },
                                            "total": {
                                                "design": Layout.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Cart.Subtotal}}`, token: Token.Cart.Subtotal }),
                                                "width": {
                                                    "unit": "px",
                                                    "value": "80"
                                                }
                                            },
                                            "layout": {
                                                "paddingBottom": {
                                                    "value": "5",
                                                    "unit": "px"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Cart.Subtotal}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Cart.Subtotal
                                        }
                                    },
                                    {
                                        "config": {
                                            "label": {
                                                "design": Layout.wrapTextForEditor({ text: 'Estimated Tax', textExtras: `style="font-weight:bold;"` }),
                                                "marginRight": {
                                                    "value": "10",
                                                    "unit": "px"
                                                }
                                            },
                                            "total": {
                                                "design": Layout.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Cart.EstimatedTax}}`, token: Token.Cart.EstimatedTax }),
                                                "width": {
                                                    "unit": "px",
                                                    "value": "80"
                                                }
                                            },
                                            "layout": {
                                                "paddingBottom": {
                                                    "value": "5",
                                                    "unit": "px"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Cart.Tax}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Cart.Tax
                                        }
                                    },
                                    {
                                        "config": {
                                            "label": {
                                                "design": Layout.wrapTextForEditor({ text: 'Estimated Shipping', textExtras: `style="font-weight:bold;"` }),
                                                "marginRight": {
                                                    "value": "10",
                                                    "unit": "px"
                                                }
                                            },
                                            "total": {
                                                "design": Layout.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Cart.EstimatedShipping}}`, token: Token.Cart.EstimatedShipping }),
                                                "width": {
                                                    "unit": "px",
                                                    "value": "80"
                                                }
                                            },
                                            "layout": {
                                                "paddingBottom": {
                                                    "value": "10",
                                                    "unit": "px"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Cart.Shipping}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Cart.Shipping
                                        }
                                    }
                                ],
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "displayText": `${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: 'Billing Information', textExtras: `style="display:inline-block;margin:0px 0px 20px;"` })}${Layout.wrapTextForEditor({ text: 'Please enter your credit card and shipping information. You will receive an email confirmation.' })}`
                                            },
                                            "container": {},
                                            "layout": {
                                                "minWidth": {
                                                    "value": "100",
                                                    "unit": "%"
                                                },
                                                "paddingBottom": {
                                                    "value": "40",
                                                    "unit": "px"
                                                },
                                                "paddingTop": {
                                                    "value": "5",
                                                    "unit": "px"
                                                },
                                                "textAlign": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Text}-2-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Text
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: 'Credit Card Information' })
                                            },
                                            "container": {},
                                            "layout": {
                                                "minWidth": {
                                                    "value": "100",
                                                    "unit": "%"
                                                },
                                                "paddingBottom": {
                                                    "value": "30",
                                                    "unit": "px"
                                                },
                                                "textAlign": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Text}-3-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Text
                                        }
                                    },
                                    {
                                        "config": {
                                            "layout": {
                                                "design": Defaults.Block[Name.Block.Cart.CardForm.Container],
                                                "paddingBottom": {
                                                    "value": "40",
                                                    "unit": "px"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Cart.CardForm.Container}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Cart.CardForm.Container
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "buttonDesign": Kit.Context.Button.Primary,
                                                "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'PAY WITH CREDIT CARD' }),
                                                "borderRadius": {
                                                    "value": "",
                                                    "unit": "px"
                                                }
                                            },
                                            "hover": {},
                                            "layout": {
                                                "alignment": "center",
                                                "marginBottom": {
                                                    "value": "40",
                                                    "unit": "px"
                                                },
                                                "paddingLeft": {
                                                    "value": "14",
                                                    "unit": "px"
                                                },
                                                "paddingRight": {
                                                    "value": "14",
                                                    "unit": "px"
                                                },
                                                "height": {
                                                    "value": "40",
                                                    "unit": "px"
                                                },
                                                "width": {
                                                    "unit": "%",
                                                    "value": "100"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Cart.PurchaseButtonV2}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Cart.PurchaseButtonV2
                                        }
                                    }
                                ]
                            ]
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "65"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "65"
                                }
                            }
                        },
                        "display": "Cart Template",
                        "id": "pageSettings",
                        "type": PageType.Cart
                    }
                },
                [CartMode.emptyCart]: {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header2, text: 'Shopping Cart' })
                                },
                                "container": {},
                                "layout": {
                                    "minWidth": {
                                        "unit": "%",
                                        "value": "100"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-empty-1-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ text: 'Your shopping cart is empty' })
                                },
                                "container": {},
                                "layout": {
                                    "minWidth": {
                                        "unit": "%",
                                        "value": "100"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-empty-2-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "65"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "65"
                                }
                            }
                        },
                        "display": "Cart Template",
                        "id": "pageSettings",
                        "type": PageType.Cart
                    }
                },
                [CartMode.purchaseConfirmation]: {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header2, text: 'Shopping Cart' })
                                },
                                "container": {},
                                "layout": {
                                    "minWidth": {
                                        "unit": "%",
                                        "value": "100"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-confirmation-1-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ text: 'Thank you for your purchase! You will receive an email confirmation.' })
                                },
                                "container": {},
                                "layout": {
                                    "minWidth": {
                                        "unit": "%",
                                        "value": "100"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-confirmation-2-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "65"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "65"
                                }
                            }
                        },
                        "display": "Cart Template",
                        "id": "pageSettings",
                        "type": PageType.Cart
                    }
                }
            };
        },
        [PageType.Content.Presentation.InventoryDetailModal]: (config, { artist, availability = true, cta, dimensions = true, medium = true, price = true } = {}, themeConfig = {}) => {
            const theme = Defaults.Block[Kit.Type.Presentation].getTheme(themeConfig);
            const presentationKit = Kit.presentationKit(config, PageType.Custom);
            const colorBodyBackground = (presentationKit && presentationKit.backgroundColor) || '';
            const contentBlocks = [];
            if (artist || config?.artist == undefined) {
                contentBlocks.push({
                    "config": {
                        "block": {
                            "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.ArtistName}("before":"","after":"")}`, textExtras: `style="${theme.color ? `color:${theme.color.main};` : ''}font-weight:500;"`, token: Token.ArtistName }),
                        },
                        "layout": {
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Text}-artist`,
                    "type": {
                        "value": Name.Block.Inventory.Text
                    }
                });
            }
            let textExtras = `${theme.color ? `color:${theme.color.secondary};font-weight:500;` : ''}`;
            const title = `<p class="${Kit.Context.Global.Header3}">${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;${textExtras}"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;${textExtras}"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;${textExtras}"`, token: Token.Date, wrapWithTag: false })}</p>`;
            contentBlocks.push({
                "config": {
                    "block": {
                        "design": title,
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "16",
                            "unit": "px"
                        },
                        "textAlign": "center"
                    }
                },
                "id": `${Name.Block.Inventory.Text}-title`,
                "type": {
                    "value": Name.Block.Inventory.Text
                }
            });
            const details = [];
            if (medium) {
                details.push({ text: `{${Token.Medium}("before":"","after":"")}`, token: Token.Medium });
            }
            if (dimensions) {
                details.push({ text: `{${Token.Dimensions}("before":"","after":"")}`, token: Token.Dimensions });
                details.push({ text: `{${Token.AlternateDimensions}("before":"","after":"")}`, token: Token.AlternateDimensions });
            }
            if (price) {
                details.push({ text: `{${Token.PriceWithoutOverride}("showIfSold":"true","before":"","after":"")}`, token: Token.PriceWithoutOverride });
            }
            if (details.length > 0) {
                textExtras = `${theme.color ? `color:${theme.color.description};` : ''}line-height:24px;`
                let detailText = '';
                for (let i = 0; i < details.length; i++) {
                    detailText += Layout.wrapTextForEditor({ ...details[i], tag: Kit.Context.Global.Header5, textExtras: `style="${textExtras}"` });
                }
                contentBlocks.push({
                    "config": {
                        "block": {
                            "design": detailText
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "12",
                                "unit": "px"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Text}-details`,
                    "type": {
                        "value": Name.Block.Inventory.Text
                    }
                });
            }
            if (availability) {
                const availabilityExtras = `${theme.color ? `color:${theme.color.description};` : ''}`;
                contentBlocks.push({
                    "config": {
                        "block": {
                            "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: `{${Token.AvailabilityStatus}("availableLabel":"","unavailableLabel":"","colorAvailable":"","colorUnavailable":"","size":"","showIfAvailable":"true")}`, textExtras: `style="${availabilityExtras}"`, token: Token.AvailabilityStatus })
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "32",
                                "unit": "px"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Text}-availability`,
                    "type": {
                        "value": Name.Block.Inventory.Text
                    }
                });
            }
            if (cta?.visible) {
                contentBlocks.push({
                    "config": {
                        "block": {
                            "borderTopColor": theme.color?.button,
                            "borderBottomColor": theme.color?.button,
                            "borderLeftColor": theme.color?.button,
                            "borderRightColor": theme.color?.button,
                            "buttonDesign": Kit.Context.Button.Secondary,
                            "buttonType": InventoryCTAButtonType.Inquire,
                            "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: cta.text == undefined ? 'Inquire' : cta.text, textColor: theme.color?.button })
                        },
                        "hover": {},
                        "layout": {
                            "alignment": "center",
                            "marginBottom": {
                                "value": "32",
                                "unit": "px"
                            }
                        }
                    },
                    "id": Name.Block.Inventory.Button.InquireV3,
                    "type": {
                        "value": Name.Block.Inventory.Button.InquireV3
                    }
                });
            }
            contentBlocks.push({
                "config": {
                    "block": {
                        "paddingBottom": {
                            "value": "32",
                            "unit": "px"
                        },
                        "backgroundColor": "transparent",
                        "content": {
                            "desktop": {
                                "blocks": [
                                    {
                                        "config": {
                                            "block": {
                                                "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: `{${Token.Provenance}("before":"","after":"")}`, textExtras: `style="${theme.color ? `color:${theme.color.description};` : ''}line-height:20px;"`, token: Token.Provenance })
                                            },
                                            "layout": {
                                                "textAlign": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Text}-provenance`,
                                        "type": {
                                            "value": Name.Block.Inventory.Text
                                        }
                                    }
                                ],
                                "page": {
                                    "config": {},
                                    "type": PageType.Content.InventoryAccordion,
                                    "display": "Accordion Content",
                                    "id": "pageSettings"
                                }
                            }
                        }
                    },
                    "header": {
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: 'Provenance', textExtras: `style="font-weight:500;line-height:20px;"` }),
                        "paddingBottom": {
                            "value": "16",
                            "unit": "px"
                        },
                        "paddingTop": {
                            "value": "16",
                            "unit": "px"
                        },
                        "indicatorType": "plusMinus",
                        "arrowSize": {
                            "unit": "px",
                            "value": "16"
                        },
                        "backgroundColorClosed": "transparent",
                        "backgroundColorOpen": "transparent"
                    },
                    "layout": {
                        "alignment": "center",
                        "borderTopColor": "rgba(223,226,230,1)",
                        "borderTopStyle": "solid",
                        "borderTopWidth": {
                            "unit": "px",
                            "value": "1"
                        },
                        "marginLeft": {
                            "unit": "px",
                            "value": "0"
                        },
                        "marginRight": {
                            "unit": "px",
                            "value": "0"
                        },
                        "maxWidth": {
                            "unit": "%",
                            "value": "100"
                        }
                    }
                },
                "id": `${Name.Block.Accordion}-provinance-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Accordion
                }
            });
            const buttonProps = {
                "borderTopColor": theme.color.border,
                "borderBottomColor": theme.color.border,
                "borderLeftColor": theme.color.border,
                "borderRightColor": theme.color.border
            }
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "columnCount": "1",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "tr",
                                    "backgroundColor": null
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "position": "fixed",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false,
                                    "maxWidth": {
                                        "unit": "%",
                                        "value": "100"
                                    },
                                    "top": {
                                        "unit": "px",
                                        "value": "0"
                                    },
                                    "zIndex": "1"
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-top-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "color": theme.color.button,
                                                "fontSize": {
                                                    "unit": "px",
                                                    "value": "12"
                                                },
                                                "borderRadius": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "borderTopStyle": "solid",
                                                "borderTopWidth": {
                                                    "unit": "px",
                                                    "value": "1"
                                                },
                                                "borderBottomStyle": "solid",
                                                "borderLeftStyle": "solid",
                                                "borderRightStyle": "solid",
                                                "borderBottomWidth": {
                                                    "unit": "px",
                                                    "value": "1"
                                                },
                                                "borderLeftWidth": {
                                                    "unit": "px",
                                                    "value": "1"
                                                },
                                                "borderRightWidth": {
                                                    "unit": "px",
                                                    "value": "1"
                                                },
                                                ...buttonProps
                                            },
                                            "layout": {
                                                "alignment": "right",
                                                "marginTop": {
                                                    "unit": "px",
                                                    "value": "12"
                                                },
                                                "marginRight": {
                                                    "unit": "px",
                                                    "value": "12"
                                                },
                                                "paddingTop": {
                                                    "unit": "px",
                                                    "value": "11"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "11"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "11"
                                                },
                                                "paddingBottom": {
                                                    "unit": "px",
                                                    "value": "10"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.CloseButton
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "config": {
                                "block": {
                                    "columnCount": "2",
                                    "backgroundColor-col2": theme.color.backgroundAlt,
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "mr",
                                    "flexDirection-col2": "column",
                                    "alignment-col2": "tl",
                                    "minWidth-col2": {
                                        "unit": "px",
                                        "value": "440"
                                    },
                                    "maxWidth-col2": {
                                        "unit": "px",
                                        "value": "440"
                                    },
                                    "paddingBottom-col2": {
                                        "unit": "px",
                                        "value": "60"
                                    },
                                    "paddingLeft-col2": {
                                        "unit": "px",
                                        "value": "60"
                                    },
                                    "paddingRight-col2": {
                                        "unit": "px",
                                        "value": "60"
                                    },
                                    "paddingTop-col2": {
                                        "unit": "px",
                                        "value": "60"
                                    }
                                },
                                "layout": {
                                    "minHeight": {
                                        "unit": "%",
                                        "value": "100"
                                    },
                                    "maxHeight": {
                                        "unit": "%",
                                        "value": "100"
                                    },
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "61"
                                    },
                                    "textAlign": "center",
                                    "position": "relative",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-content-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "includeThumbnails": true,
                                                "animation": "0",
                                                "animationDuration": "300",
                                                "autoplayTimeout": "0",
                                                "arrowsVisible": false,
                                                "arrowOffset": {
                                                    "unit": "px",
                                                    "value": "0"
                                                },
                                                "itemSpacing": {
                                                    "unit": "px",
                                                    "value": "0"
                                                }
                                            },
                                            "layout": {
                                                "maxHeight": {
                                                    "unit": "vh",
                                                    "value": "90"
                                                },
                                                "maxWidth": {
                                                    "unit": "%",
                                                    "value": "100"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "60"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "60"
                                                },
                                                "paddingTop": {
                                                    "unit": "px",
                                                    "value": "60"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Image
                                        }
                                    }
                                ],
                                contentBlocks
                            ]
                        },
                        {
                            "config": {
                                "block": {
                                    "backgroundColor": theme.color.background,
                                    "columnCount": "1",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "mr"
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "position": "fixed",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false,
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                    "borderTopStyle": "solid",
                                    "borderTopWidth": {
                                        "unit": "px",
                                        "value": "1"
                                    },
                                    "borderTopColor": theme.color.border2,
                                    "bottom": {
                                        "unit": "px",
                                        "value": "0"
                                    },
                                    "zIndex": "1",
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "12"
                                    }
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-bottom-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "buttonDesign": Kit.Context.Button.Secondary,
                                                "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'Previous', textColor: theme.color?.button }),
                                                "arrowVisible": true,
                                                ...buttonProps
                                            },
                                            "hover": {},
                                            "layout": {
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.ModalButtonPrevious}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.ModalButtonPrevious
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "buttonDesign": Kit.Context.Button.Secondary,
                                                "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'Next', textColor: theme.color?.button }),
                                                "arrowVisible": true,
                                                ...buttonProps
                                            },
                                            "hover": {},
                                            "layout": {
                                                "marginLeft": {
                                                    "value": "8",
                                                    "unit": "px"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "12"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "12"
                                                },
                                                "height": {
                                                    "value": "36",
                                                    "unit": "px"
                                                },
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.ModalButtonNext}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.ModalButtonNext
                                        }
                                    }
                                ]
                            ]
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {
                                "arrowColor": theme.color.main,
                                "arrowOffset": {
                                    "value": "20",
                                    "unit": "px"
                                },
                                "arrowSize": {
                                    "value": "0",
                                    "unit": "px"
                                },
                                "backgroundColor": theme.color.background,
                                "scrollable": true
                            },
                            "layout": {}
                        },
                        "type": PageType.Content.Presentation.InventoryDetailModal,
                        "display": "Inventory Detail Modal Template",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.Content.Presentation.Popup.Inquire]: (config, { artist } = {}, themeConfig = {}) => {
            const theme = Defaults.Block[Kit.Type.Presentation].getTheme(themeConfig);
            const inventoryImage = {
                "config": {
                    "layout": {
                        "isCropped": false,
                        "marginBottom": {
                            "unit": "px",
                            "value": "20"
                        }
                    }
                },
                "id": `${Name.Block.Inventory.Cell.Image}-inquire`,
                "type": {
                    "value": Name.Block.Inventory.Cell.Image
                }
            };
            const inventoryMeta = [];
            let textExtras = `${theme.color ? `color:${theme.color.main};line-height:21px;` : ''}`;
            if (artist || config?.artist == undefined) {
                inventoryMeta.push({
                    "config": {
                        "block": {
                            "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: `{${Token.ArtistName}("before":"","after":"")}`, textExtras: `style="font-weight:500;${textExtras}"`, token: Token.ArtistName })
                        },
                        "layout": {}
                    },
                    "id": `${Name.Block.Inventory.Cell.Text}-artist`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Text
                    }
                });
            }
            const title = `<p class="${Kit.Context.Global.Header5}">${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;${textExtras}"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;${textExtras}"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;${textExtras}"`, token: Token.Date, wrapWithTag: false })}</p>`;
            inventoryMeta.push({
                "config": {
                    "block": {
                        "design": title
                    },
                    "layout": {
                        "marginBottom": {
                            "unit": "px",
                            "value": "16"
                        }
                    }
                },
                "id": `${Name.Block.Inventory.Cell.Text}-title`,
                "type": {
                    "value": Name.Block.Inventory.Cell.Text
                }
            });
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "columnCount": "2",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "ml",
                                    "maxWidth-col1": {
                                        "unit": "px",
                                        "value": ""
                                    },
                                    "flexDirection-col2": "row",
                                    "alignment-col2": "mr",
                                    "maxWidth-col2": {
                                        "unit": "px",
                                        "value": "30"
                                    }
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false,
                                    "marginBottom": {
                                        "unit": "px",
                                        "value": "16"
                                    }
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-top-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header2, text: 'Inquire about an Artwork', textExtras: `style="font-weight:500;"`, })
                                            },
                                            "container": {},
                                            "layout": {}
                                        },
                                        "id": `${Name.Block.Text}-title-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Text
                                        }
                                    }
                                ],
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "fontSize": {
                                                    "unit": "px",
                                                    "value": "12"
                                                }
                                            },
                                            "layout": {
                                                "alignment": "right",
                                                "paddingBottom": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "paddingTop": {
                                                    "unit": "px",
                                                    "value": "8"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.CloseButton
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "config": {
                                "block": {
                                    "columnCount": "2",
                                    "columnWrap": "mobile",
                                    "flexDirection-col1": "column",
                                    "alignment-col1": "tl",
                                    "maxWidth-col1": {
                                        "unit": "px",
                                        "value": "240"
                                    },
                                    "flexDirection-col2": "column",
                                    "alignment-col2": "tl",
                                    "paddingLeft-col2": {
                                        "unit": "px",
                                        "value": "16"
                                    }
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-content-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    inventoryImage,
                                    ...inventoryMeta
                                ],
                                [
                                    {
                                        "config": {
                                            "layout": {
                                                "design": Defaults.Block[Kit.Type.Presentation][Name.Block.InquireForm.Container](config, theme),
                                                "alignment": "center"
                                            }
                                        },
                                        "id": `${Name.Block.InquireForm.Container}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.InquireForm.Container
                                        }
                                    }
                                ]
                            ]
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {
                                "borderRadius": {
                                    "unit": "px",
                                    "value": "8"
                                }
                            },
                            "layout": {
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "16"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "16"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "16"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "16"
                                },
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "680"
                                }
                            }
                        },
                        "type": PageType.Content.Presentation.Popup.Inquire,
                        "display": "Inquire Popup",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.Content.Presentation.Popup.Offer]: (config) => {
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "fontSize": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                },
                                "layout": {
                                    "alignment": "right",
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "8"
                                    }
                                }
                            },
                            "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.CloseButton
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, tagExtras: `style="text-align:center;"`, text: 'Make an Offer' })
                                },
                                "container": {},
                                "layout": {
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-1-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "columnCount": "2",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "tr",
                                    "flexDirection-col2": "row",
                                    "alignment-col2": "tl",
                                    "paddingLeft-col2": {
                                        "unit": "px",
                                        "value": "10"
                                    },
                                    "paddingRight-col1": {
                                        "unit": "px",
                                        "value": "10"
                                    }
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-inventory-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "layout": {
                                                "alignItems": "center",
                                                "isCropped": true,
                                                "width": {
                                                    "unit": "px",
                                                    "value": "150"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Cell.Image}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Cell.Image
                                        }
                                    }
                                ],
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "design": `${Layout.wrapTextForEditor({ text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Dimensions}("before":"","after":"")}`, token: Token.Dimensions })}${Layout.wrapTextForEditor({ text: `{${Token.PriceWithoutOverride}("before":"","after":"")}`, token: Token.PriceWithoutOverride })}`
                                            },
                                            "container": {
                                                "animation": "0"
                                            },
                                            "layout": {}
                                        },
                                        "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Cell.Text
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'We are most likely to accept offers of 10% or less off the list price.' })
                                },
                                "container": {
                                    "animation": "0"
                                },
                                "layout": {
                                    "paddingBottom": {
                                        "value": "30",
                                        "unit": "px"
                                    },
                                    "paddingTop": {
                                        "value": "30",
                                        "unit": "px"
                                    },
                                    "textAlign": "center"
                                }
                            },
                            "id": `${Name.Block.Text}-2-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "layout": {
                                    "design": Defaults.Block[Name.Block.OfferForm.Container](config),
                                    "alignment": "center",
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "45"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "45"
                                    }
                                }
                            },
                            "id": `${Name.Block.OfferForm.Container}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.OfferForm.Container
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'You will receive an email confirmation' })
                                },
                                "container": {
                                    "animation": "0"
                                },
                                "layout": {
                                    "paddingBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "paddingTop": {
                                        "value": "30",
                                        "unit": "px"
                                    },
                                    "textAlign": "center"
                                }
                            },
                            "id": `${Name.Block.Text}-3-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "900"
                                }
                            }
                        },
                        "type": PageType.Popup.Offer,
                        "display": "Offer Popup",
                        "id": "pageSettings"
                    }
                }
            }
        },

        [PageType.CookiePolicy]: (_) => {
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: 'We Value Your Privacy' })
                                },
                                "container": {},
                                "layout": {
                                    "marginBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-1-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, text: 'We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and for marketing purposes. By continuing to use our site, you consent to our use of cookies.' })
                                },
                                "container": {},
                                "layout": {
                                    "marginBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-2-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Primary,
                                    "buttonType": CookiePolicyButtonType.Accept,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, text: 'CONTINUE' })
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "alignment": "right"
                                }
                            },
                            "id": `${Name.Block.CookiePolicy.Button.Accept}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.CookiePolicy.Button.Accept
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {
                                "borderTopStyle": "solid",
                                "borderTopWidth": {
                                    "unit": "px",
                                    "value": "2"
                                },
                                "borderBottomStyle": "solid",
                                "borderLeftStyle": "solid",
                                "borderRightStyle": "solid",
                                "borderBottomWidth": {
                                    "unit": "px",
                                    "value": "2"
                                },
                                "borderLeftWidth": {
                                    "unit": "px",
                                    "value": "2"
                                },
                                "borderRightWidth": {
                                    "unit": "px",
                                    "value": "2"
                                }
                            },
                            "layout": {
                                "alignment": "br",
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "400"
                                },
                                "marginTop": {
                                    "unit": "px",
                                    "value": "20"
                                },
                                "marginBottom": {
                                    "unit": "px",
                                    "value": "20"
                                },
                                "marginRight": {
                                    "unit": "px",
                                    "value": "20"
                                },
                                "marginLeft": {
                                    "unit": "px",
                                    "value": "20"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "20"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "20"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "20"
                                },
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "20"
                                }
                            }
                        },
                        "type": PageType.CookiePolicy,
                        "display": "Cookie Policy",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.InventoryDetailModal]: (config) => {
            const colorBodyBackground = (config.colors && config.colors.bodyBackground) || '';
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "columnCount": "1",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "tr",
                                    "backgroundColor": null
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "position": "fixed",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false,
                                    "maxWidth": {
                                        "unit": "%",
                                        "value": "100"
                                    },
                                    "top": {
                                        "unit": "px",
                                        "value": "0"
                                    },
                                    "zIndex": "1"
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-top-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "fontSize": {
                                                    "unit": "px",
                                                    "value": "20"
                                                }
                                            },
                                            "layout": {
                                                "alignment": "right",
                                                "marginTop": {
                                                    "unit": "px",
                                                    "value": "30"
                                                },
                                                "marginRight": {
                                                    "unit": "px",
                                                    "value": "30"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.CloseButton
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "config": {
                                "block": {
                                    "columnCount": "1",
                                    "flexDirection-col1": "column",
                                    "alignment-col1": "mc"
                                },
                                "layout": {
                                    "minHeight": {
                                        "unit": "%",
                                        "value": "100"
                                    },
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "132"
                                    },
                                    "textAlign": "center",
                                    "position": "relative",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-content-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "includeThumbnails": true,
                                                "itemSpacing": {
                                                    "unit": "px",
                                                    "value": "0"
                                                },
                                                "arrowsVisible": false
                                            },
                                            "layout": {
                                                "marginLeft": {
                                                    "unit": "px",
                                                    "value": ""
                                                },
                                                "marginRight": {
                                                    "unit": "px",
                                                    "value": ""
                                                },
                                                "paddingBottom": {
                                                    "value": "",
                                                    "unit": "px"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "40"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "40"
                                                },
                                                "height": {
                                                    "unit": "vh",
                                                    "value": "85"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Image
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "config": {
                                "block": {
                                    "columnCount": "2",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "mr",
                                    "flexDirection-col2": "row",
                                    "alignment-col2": "ml",
                                    "borderLeftWidth-col2": {
                                        "unit": "px",
                                        "value": "1"
                                    },
                                    "borderLeftColor-col2": "rgba(214,214,214,1)",
                                    "paddingLeft-col2": {
                                        "unit": "px",
                                        "value": "40"
                                    },
                                    "paddingRight-col1": {
                                        "unit": "px",
                                        "value": "40"
                                    },
                                    "backgroundColor": colorBodyBackground
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "position": "fixed",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false,
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "15"
                                    },
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "15"
                                    },
                                    "borderTopStyle": "solid",
                                    "borderTopWidth": {
                                        "unit": "px",
                                        "value": "1"
                                    },
                                    "borderTopColor": "rgba(214,214,214,1)",
                                    "bottom": {
                                        "unit": "px",
                                        "value": "0"
                                    },
                                    "zIndex": "1",
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "30"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "30"
                                    }
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-bottom-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "design": `<p class="p" style="text-align:right;">${Layout.wrapTextForEditor({ text: `{${Token.ArtistName}("before":"","after":"")}`, textExtras: `style="display:inline-block;font-weight:bold;margin:0 6px 0 0;"`, token: Token.ArtistName, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="font-style:italic;"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Edition}("before":" (","after":")")}`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, token: Token.Date, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Medium}("before":"","after":"")}`, textExtras: `style="display:inline-block;margin:0 0 0 6px;"`, token: Token.Medium, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Dimensions}("before":"","after":"")}`, textExtras: `style="display:inline-block;margin:0 0 0 6px;"`, token: Token.Dimensions, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Price}("showIfSold":"true","before":"","after":"")}`, textExtras: `style="display:inline-block;margin:0 0 0 6px;"`, token: Token.Price, wrapWithTag: false })}</p>`
                                            },
                                            "layout": {
                                                "marginBottom": {
                                                    "value": "5",
                                                    "unit": "px"
                                                },
                                                "marginTop": {
                                                    "unit": "px",
                                                    "value": "5"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": ""
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": ""
                                                },
                                                "textAlign": "center"
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Text}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Text
                                        }
                                    },
                                ],
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "buttonDesign": Kit.Context.Button.Primary,
                                                "buttonType": InventoryCTAButtonType.Purchase,
                                                "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'PURCHASE' })
                                            },
                                            "hover": {},
                                            "layout": {
                                                "alignment": "center",
                                                "marginBottom": {
                                                    "value": "5",
                                                    "unit": "px"
                                                },
                                                "marginLeft": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "marginRight": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "marginTop": {
                                                    "unit": "px",
                                                    "value": "5"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "14"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "14"
                                                },
                                                "height": {
                                                    "value": "40",
                                                    "unit": "px"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Button.PurchaseV3}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Button.PurchaseV3
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "buttonDesign": Kit.Context.Button.Primary,
                                                "buttonType": InventoryCTAButtonType.Offer,
                                                "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'MAKE AN OFFER' })
                                            },
                                            "hover": {},
                                            "layout": {
                                                "alignment": "center",
                                                "marginBottom": {
                                                    "value": "5",
                                                    "unit": "px"
                                                },
                                                "marginLeft": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "marginRight": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "marginTop": {
                                                    "unit": "px",
                                                    "value": "5"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "14"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "14"
                                                },
                                                "height": {
                                                    "value": "40",
                                                    "unit": "px"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Button.OfferV3}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Button.OfferV3
                                        }
                                    },
                                    {
                                        "config": {
                                            "block": {
                                                "buttonDesign": Kit.Context.Button.Primary,
                                                "buttonType": InventoryCTAButtonType.Inquire,
                                                "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'INQUIRE' })
                                            },
                                            "hover": {},
                                            "layout": {
                                                "alignment": "center",
                                                "marginBottom": {
                                                    "value": "5",
                                                    "unit": "px"
                                                },
                                                "marginLeft": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "marginRight": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "marginTop": {
                                                    "unit": "px",
                                                    "value": "5"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "14"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "14"
                                                },
                                                "height": {
                                                    "value": "40",
                                                    "unit": "px"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Button.InquireV3}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Button.InquireV3
                                        }
                                    }
                                ]
                            ]
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {
                                "scrollable": false
                            },
                            "layout": {
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "53"
                                },
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": ""
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": ""
                                }
                            }
                        },
                        "type": PageType.InventoryDetailModal,
                        "display": "Inventory Detail Modal Template",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.PasswordProtection]: () => {
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'A password is required to view this page' })
                                },
                                "container": {},
                                "layout": {
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "layout": {
                                    "alignment": "center",
                                    "maxWidth": {
                                        "unit": "px",
                                        "value": "500"
                                    }
                                }
                            },
                            "id": `${Name.Block.PasswordForm.Container}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PasswordForm.Container
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {}
                        },
                        "type": PageType.PasswordProtection,
                        "display": "Password Protection",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.Popup.Inquire]: (config) => {
            const accentColor = (config.colors && config.colors.accent) || ''
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "columnCount": "3",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "tl",
                                    "maxWidth-col1": {
                                        "unit": "px",
                                        "value": "40"
                                    },
                                    "flexDirection-col2": "row",
                                    "alignment-col2": "tc",
                                    "flexDirection-col3": "row",
                                    "alignment-col3": "tl",
                                    "maxWidth-col3": {
                                        "unit": "px",
                                        "value": "40"
                                    }
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false,
                                    "marginBottom": {
                                        "unit": "px",
                                        "value": "40"
                                    }
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [],
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header1, tagExtras: `style="text-align:center;"`, text: 'Inquire' })
                                            },
                                            "container": {},
                                            "layout": {}
                                        },
                                        "id": `${Name.Block.Text}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Text
                                        }
                                    }
                                ],
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "fontSize": {
                                                    "unit": "px",
                                                    "value": "12"
                                                },
                                                "color": accentColor
                                            },
                                            "layout": {
                                                "alignment": "right",
                                                "paddingBottom": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "paddingLeft": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "paddingRight": {
                                                    "unit": "px",
                                                    "value": "8"
                                                },
                                                "paddingTop": {
                                                    "unit": "px",
                                                    "value": "8"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.CloseButton
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "config": {
                                "layout": {
                                    "design": Defaults.Block[Name.Block.InquireForm.Container](config),
                                    "alignment": "center",
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "45"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "45"
                                    }
                                }
                            },
                            "id": `${Name.Block.InquireForm.Container}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.InquireForm.Container
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "500"
                                }
                            }
                        },
                        "type": PageType.Popup.Inquire,
                        "display": "Inquire Popup",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.Popup.Offer]: (config) => {
            const accentColor = (config.colors && config.colors.accent) || ''
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "fontSize": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                    "color": accentColor
                                },
                                "layout": {
                                    "alignment": "right",
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "8"
                                    }
                                }
                            },
                            "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.CloseButton
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, tagExtras: `style="text-align:center;"`, text: 'Make an Offer' })
                                },
                                "container": {},
                                "layout": {
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-1-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "columnCount": "2",
                                    "flexDirection-col1": "row",
                                    "alignment-col1": "tr",
                                    "flexDirection-col2": "row",
                                    "alignment-col2": "tl",
                                    "paddingLeft-col2": {
                                        "unit": "px",
                                        "value": "10"
                                    },
                                    "paddingRight-col1": {
                                        "unit": "px",
                                        "value": "10"
                                    }
                                },
                                "layout": {
                                    "textAlign": "center",
                                    "backgroundPosition": "mc",
                                    "backgroundSize": "contain",
                                    "backgroundRepeatX": false,
                                    "backgroundRepeatY": false
                                }
                            },
                            "dataType": "layout",
                            "id": `${Name.Block.Columns}-inventory-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Columns
                            },
                            "blocks": [
                                [
                                    {
                                        "config": {
                                            "layout": {
                                                "alignItems": "center",
                                                "isCropped": true,
                                                "width": {
                                                    "unit": "px",
                                                    "value": "150"
                                                }
                                            }
                                        },
                                        "id": `${Name.Block.Inventory.Cell.Image}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Cell.Image
                                        }
                                    }
                                ],
                                [
                                    {
                                        "config": {
                                            "block": {
                                                "design": `${Layout.wrapTextForEditor({ text: `{${Token.ArtistName}("before":"","after":"")}`, token: Token.ArtistName })}<p class="p">${Layout.wrapTextForEditor({ text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Layout.wrapTextForEditor({ text: `{${Token.Dimensions}("before":"","after":"")}`, token: Token.Dimensions })}${Layout.wrapTextForEditor({ text: `{${Token.Price}("before":"","after":"")}`, token: Token.Price })}`
                                            },
                                            "container": {
                                                "animation": "0"
                                            },
                                            "layout": {}
                                        },
                                        "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                                        "type": {
                                            "value": Name.Block.Inventory.Cell.Text
                                        }
                                    }
                                ]
                            ]
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'We are most likely to accept offers of 10% or less off the list price.' })
                                },
                                "container": {
                                    "animation": "0"
                                },
                                "layout": {
                                    "paddingBottom": {
                                        "value": "30",
                                        "unit": "px"
                                    },
                                    "paddingTop": {
                                        "value": "30",
                                        "unit": "px"
                                    },
                                    "textAlign": "center"
                                }
                            },
                            "id": `${Name.Block.Text}-2-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "layout": {
                                    "design": Defaults.Block[Name.Block.OfferForm.Container](config),
                                    "alignment": "center",
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "45"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "45"
                                    }
                                }
                            },
                            "id": `${Name.Block.OfferForm.Container}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.OfferForm.Container
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'You will receive an email confirmation' })
                                },
                                "container": {
                                    "animation": "0"
                                },
                                "layout": {
                                    "paddingBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "paddingTop": {
                                        "value": "30",
                                        "unit": "px"
                                    },
                                    "textAlign": "center"
                                }
                            },
                            "id": `${Name.Block.Text}-3-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "900"
                                }
                            }
                        },
                        "type": PageType.Popup.Offer,
                        "display": "Offer Popup",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.Popup.Purchase]: (config) => {
            const accentColor = (config.colors && config.colors.accent) || ''
            return {
                [PurchasePopupMode.editionSelection]: {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "fontSize": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                    "color": accentColor
                                },
                                "layout": {
                                    "alignment": "right",
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "8"
                                    }
                                }
                            },
                            "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.CloseButton
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, tagExtras: `style="text-align:center;"`, text: 'Add To Cart' })
                                },
                                "container": {},
                                "layout": {
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.InputText}}`, token: Token.InputText }),
                                    "type": Name.Block.PurchasePopup.DropDown.MediaV2
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "marginBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.DropDown.MediaV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.DropDown.MediaV2
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.InputText}}`, token: Token.InputText }),
                                    "type": Name.Block.PurchasePopup.DropDown.DimensionsV2
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "marginBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.DropDown.DimensionsV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.DropDown.DimensionsV2
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.InputText}}`, token: Token.InputText }),
                                    "type": Name.Block.PurchasePopup.DropDown.PriceV2
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "marginBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.DropDown.PriceV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.DropDown.PriceV2
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Primary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'Add To Cart' })
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.SubmitButtonV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.SubmitButtonV2
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "500"
                                }
                            }
                        },
                        "type": PageType.Popup.Purchase,
                        "display": "Purchase Popup",
                        "id": "pageSettings"
                    }
                },
                [PurchasePopupMode.confirmation]: {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "fontSize": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                    "color": accentColor
                                },
                                "layout": {
                                    "alignment": "right",
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "8"
                                    }
                                }
                            },
                            "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.CloseButton
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, tagExtras: `style="text-align:center;"`, text: 'Added To Cart' })
                                },
                                "container": {},
                                "layout": {
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.InputText}}`, token: Token.InputText }),
                                    "type": Name.Block.PurchasePopup.DropDown.Framing
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "marginBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.DropDown.Framing}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.DropDown.Framing
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.InputText}}`, token: Token.InputText }),
                                    "type": Name.Block.PurchasePopup.DropDown.MediaV2
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "marginBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.DropDown.MediaV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.DropDown.MediaV2
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.InputText}}`, token: Token.InputText }),
                                    "type": Name.Block.PurchasePopup.DropDown.DimensionsV2
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "marginBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.DropDown.DimensionsV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.DropDown.DimensionsV2
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.InputText}}`, token: Token.InputText }),
                                    "type": Name.Block.PurchasePopup.DropDown.PriceV2
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "marginBottom": {
                                        "value": "20",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.DropDown.PriceV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.DropDown.PriceV2
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Primary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'Continue Shopping' })
                                },
                                "hover": {},
                                "layout": {
                                    "marginBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.ContinueButtonV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.ContinueButtonV2
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Secondary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'View Cart' })
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.PurchasePopup.CartButtonV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.PurchasePopup.CartButtonV2
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "500"
                                }
                            }
                        },
                        "type": PageType.Popup.Purchase,
                        "display": "Purchase Popup",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.Popup.Subscribe]: (config) => {
            const accentColor = (config.colors && config.colors.accent) || ''
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "fontSize": {
                                        "unit": "px",
                                        "value": "12"
                                    },
                                    "color": accentColor
                                },
                                "layout": {
                                    "alignment": "right",
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "8"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "8"
                                    }
                                }
                            },
                            "id": `${Name.Block.CloseButton}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.CloseButton
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, tagExtras: `style="text-align:center;"`, text: 'Join Our Newsletter' })
                                },
                                "container": {},
                                "layout": {
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Text}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "layout": {
                                    "design": {
                                        "desktop": {
                                            "blocks": [
                                                {
                                                    "config": {
                                                        "block": {
                                                            "type": "Name",
                                                            "borderRadius": {
                                                                "value": "2",
                                                                "unit": "px"
                                                            }
                                                        },
                                                        "layout": {
                                                            "marginBottom": {
                                                                "value": "20",
                                                                "unit": "px"
                                                            },
                                                            "paddingLeft": {
                                                                "value": "15",
                                                                "unit": "px"
                                                            },
                                                            "paddingRight": {
                                                                "value": "15",
                                                                "unit": "px"
                                                            },
                                                            "height": {
                                                                "value": "40",
                                                                "unit": "px"
                                                            },
                                                            "width": {
                                                                "value": "100",
                                                                "unit": "%"
                                                            },
                                                            "alignment": "center"
                                                        }
                                                    },
                                                    "id": `${Name.Block.SubscribeForm.Input.Name}-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.SubscribeForm.Input.Name
                                                    }
                                                },
                                                {
                                                    "config": {
                                                        "block": {
                                                            "type": "Email",
                                                            "borderRadius": {
                                                                "value": "2",
                                                                "unit": "px"
                                                            }
                                                        },
                                                        "layout": {
                                                            "marginBottom": {
                                                                "value": "20",
                                                                "unit": "px"
                                                            },
                                                            "paddingLeft": {
                                                                "value": "15",
                                                                "unit": "px"
                                                            },
                                                            "paddingRight": {
                                                                "value": "15",
                                                                "unit": "px"
                                                            },
                                                            "height": {
                                                                "value": "40",
                                                                "unit": "px"
                                                            },
                                                            "width": {
                                                                "value": "100",
                                                                "unit": "%"
                                                            },
                                                            "alignment": "center"
                                                        }
                                                    },
                                                    "id": `${Name.Block.SubscribeForm.Input.Email}-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.SubscribeForm.Input.Email
                                                    }
                                                },
                                                {
                                                    "config": {
                                                        "block": {
                                                            "buttonDesign": Kit.Context.Button.Primary,
                                                            "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'SUBSCRIBE' })
                                                        },
                                                        "hover": {},
                                                        "layout": {
                                                            "paddingLeft": {
                                                                "value": "10",
                                                                "unit": "px"
                                                            },
                                                            "paddingRight": {
                                                                "value": "10",
                                                                "unit": "px"
                                                            },
                                                            "height": {
                                                                "value": "40",
                                                                "unit": "px"
                                                            },
                                                            "width": {
                                                                "value": "100",
                                                                "unit": "%"
                                                            },
                                                            "alignment": "center"
                                                        }
                                                    },
                                                    "id": `${Name.Block.SubscribeForm.SubmitButtonV2}-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.SubscribeForm.SubmitButtonV2
                                                    }
                                                },
                                                {
                                                    "config": {
                                                        "block": {
                                                            "design": Defaults.Block.ErrorMessage()
                                                        },
                                                        "layout": {
                                                            "paddingTop": {
                                                                "value": "10",
                                                                "unit": "px"
                                                            },
                                                            "alignment": "center"
                                                        }
                                                    },
                                                    "id": `${Name.Block.SubscribeForm.ErrorMessage}-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.SubscribeForm.ErrorMessage
                                                    }
                                                },
                                                {
                                                    "config": {
                                                        "block": {
                                                            "design": Layout.wrapTextForEditor({ text: 'Thank you for subscribing to our mailing list!' })
                                                        },
                                                        "layout": {
                                                            "paddingTop": {
                                                                "value": "10",
                                                                "unit": "px"
                                                            },
                                                            "alignment": "center"
                                                        }
                                                    },
                                                    "id": `${Name.Block.SubscribeForm.SuccessMessage}-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.SubscribeForm.SuccessMessage
                                                    }
                                                }
                                            ],
                                            "page": {
                                                "config": {},
                                                "type": PageType.Form.Subscribe,
                                                "display": 'Subscribe Form',
                                                "id": "pageSettings"
                                            }
                                        }
                                    },
                                    "alignment": "center",
                                    "paddingLeft": {
                                        "unit": "px",
                                        "value": "45"
                                    },
                                    "paddingRight": {
                                        "unit": "px",
                                        "value": "45"
                                    }
                                }
                            },
                            "id": `${Name.Block.SubscribeForm.Container}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.SubscribeForm.Container
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {
                                "paddingLeft": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingRight": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingTop": {
                                    "unit": "px",
                                    "value": "30"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "maxWidth": {
                                    "unit": "px",
                                    "value": "500"
                                }
                            }
                        },
                        "type": PageType.Popup.Subscribe,
                        "display": "Subscribe Popup",
                        "id": "pageSettings"
                    }
                }
            }
        },
        [PageType.SearchResults]: () => {
            return {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "block": {
                                    "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header1, text: 'SEARCH RESULTS' }),
                                },
                                "layout": {
                                    "marginBottom": {
                                        "unit": "px",
                                        "value": "38"
                                    },
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "14"
                                    },
                                    "paddingTop": {
                                        "unit": "px",
                                        "value": "17"
                                    },
                                    "textAlign": "center"
                                }
                            },
                            "id": `${Name.Block.Text}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Text
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "lineSpacing": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "columns": "1",
                                    "artistCell": {
                                        "desktop": {
                                            "blocks": [
                                                {
                                                    "config": {
                                                        "block": {
                                                            "alignment-col1": "tc",
                                                            "alignment-col2": "tl",
                                                            "columnCount": "2",
                                                            "flexDirection-col1": "column",
                                                            "flexDirection-col2": "row",
                                                            "maxWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "minWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "paddingLeft-col2": {
                                                                "unit": "px",
                                                                "value": "50"
                                                            }
                                                        },
                                                        "layout": {
                                                            "borderBottomColor": "rgba(221,221,221,1)",
                                                            "borderBottomStyle": "solid",
                                                            "borderBottomWidth": {
                                                                "unit": "px",
                                                                "value": "1"
                                                            },
                                                            "minHeight": {
                                                                "unit": "px",
                                                                "value": "190"
                                                            },
                                                            "paddingBottom": {
                                                                "unit": "px",
                                                                "value": "40"
                                                            },
                                                            "textAlign": "center"
                                                        }
                                                    },
                                                    "dataType": "layout",
                                                    "id": `${Name.Block.Columns}-artistSearchResultsCell-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.Columns
                                                    },
                                                    "blocks": [
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "borderRadius": {
                                                                            "unit": "px",
                                                                            "value": "3"
                                                                        },
                                                                        "borderTopStyle": "solid",
                                                                        "borderTopWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderTopColor": "#bbbbbb",
                                                                        "borderBottomColor": "#bbbbbb",
                                                                        "borderLeftColor": "#bbbbbb",
                                                                        "borderRightColor": "#bbbbbb",
                                                                        "borderBottomStyle": "solid",
                                                                        "borderLeftStyle": "solid",
                                                                        "borderRightStyle": "solid",
                                                                        "borderBottomWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderLeftWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderRightWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        }
                                                                    },
                                                                    "layout": {
                                                                        "isCropped": false,
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "150"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Image.Artist}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Image.Artist
                                                                }
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Artist]()
                                                                    },
                                                                    "layout": {
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "143"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Text.Artist}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Text.Artist
                                                                }
                                                            }
                                                        ]
                                                    ]
                                                }
                                            ],
                                            "page": {
                                                "config": {
                                                    "block": {},
                                                    "layout": {}
                                                },
                                                "type": PageType.Content.SearchResultCell.Artist,
                                                "display": "Artist Search Result Cell Template",
                                                "id": "pageSettings"
                                            }
                                        }
                                    },
                                    "blogCell": {
                                        "desktop": {
                                            "blocks": [
                                                {
                                                    "config": {
                                                        "block": {
                                                            "alignment-col1": "tc",
                                                            "alignment-col2": "tl",
                                                            "columnCount": "2",
                                                            "flexDirection-col1": "column",
                                                            "flexDirection-col2": "row",
                                                            "maxWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "minWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "paddingLeft-col2": {
                                                                "unit": "px",
                                                                "value": "50"
                                                            }
                                                        },
                                                        "layout": {
                                                            "borderBottomColor": "rgba(221,221,221,1)",
                                                            "borderBottomStyle": "solid",
                                                            "borderBottomWidth": {
                                                                "unit": "px",
                                                                "value": "1"
                                                            },
                                                            "minHeight": {
                                                                "unit": "px",
                                                                "value": "190"
                                                            },
                                                            "paddingBottom": {
                                                                "unit": "px",
                                                                "value": "40"
                                                            },
                                                            "textAlign": "center"
                                                        }
                                                    },
                                                    "dataType": "layout",
                                                    "id": `${Name.Block.Columns}-blogSearchResultsCell-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.Columns
                                                    },
                                                    "blocks": [
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "borderRadius": {
                                                                            "unit": "px",
                                                                            "value": "3"
                                                                        },
                                                                        "borderTopStyle": "solid",
                                                                        "borderTopWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderTopColor": "#bbbbbb",
                                                                        "borderBottomColor": "#bbbbbb",
                                                                        "borderLeftColor": "#bbbbbb",
                                                                        "borderRightColor": "#bbbbbb",
                                                                        "borderBottomStyle": "solid",
                                                                        "borderLeftStyle": "solid",
                                                                        "borderRightStyle": "solid",
                                                                        "borderBottomWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderLeftWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderRightWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        }
                                                                    },
                                                                    "layout": {
                                                                        "isCropped": false,
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "150"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Image.Blog}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Image.Blog
                                                                }
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Blog]()
                                                                    },
                                                                    "layout": {
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "143"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Text.Blog}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Text.Blog
                                                                }
                                                            }
                                                        ]
                                                    ]
                                                }
                                            ],
                                            "page": {
                                                "config": {
                                                    "block": {},
                                                    "layout": {}
                                                },
                                                "type": PageType.Content.SearchResultCell.Blog,
                                                "display": "Blog Search Result Cell Template",
                                                "id": "pageSettings"
                                            }
                                        }
                                    },
                                    "inventoryCell": {
                                        "desktop": {
                                            "blocks": [
                                                {
                                                    "config": {
                                                        "block": {
                                                            "alignment-col1": "tc",
                                                            "alignment-col2": "tl",
                                                            "columnCount": "2",
                                                            "flexDirection-col1": "column",
                                                            "flexDirection-col2": "row",
                                                            "maxWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "minWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "paddingLeft-col2": {
                                                                "unit": "px",
                                                                "value": "50"
                                                            }
                                                        },
                                                        "layout": {
                                                            "borderBottomColor": "rgba(221,221,221,1)",
                                                            "borderBottomStyle": "solid",
                                                            "borderBottomWidth": {
                                                                "unit": "px",
                                                                "value": "1"
                                                            },
                                                            "minHeight": {
                                                                "unit": "px",
                                                                "value": "190"
                                                            },
                                                            "paddingBottom": {
                                                                "unit": "px",
                                                                "value": "40"
                                                            },
                                                            "textAlign": "center"
                                                        }
                                                    },
                                                    "dataType": "layout",
                                                    "id": `${Name.Block.Columns}-inventorySearchResultsCell-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.Columns
                                                    },
                                                    "blocks": [
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "borderRadius": {
                                                                            "unit": "px",
                                                                            "value": "3"
                                                                        },
                                                                        "borderTopStyle": "solid",
                                                                        "borderTopWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderTopColor": "#bbbbbb",
                                                                        "borderBottomColor": "#bbbbbb",
                                                                        "borderLeftColor": "#bbbbbb",
                                                                        "borderRightColor": "#bbbbbb",
                                                                        "borderBottomStyle": "solid",
                                                                        "borderLeftStyle": "solid",
                                                                        "borderRightStyle": "solid",
                                                                        "borderBottomWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderLeftWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderRightWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        }
                                                                    },
                                                                    "layout": {
                                                                        "isCropped": false,
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "150"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Image.Inventory}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Image.Inventory
                                                                }
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Inventory]()
                                                                    },
                                                                    "layout": {
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "143"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Text.Inventory}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Text.Inventory
                                                                }
                                                            }
                                                        ]
                                                    ]
                                                }
                                            ],
                                            "page": {
                                                "config": {
                                                    "block": {},
                                                    "layout": {}
                                                },
                                                "type": PageType.Content.SearchResultCell.Inventory,
                                                "display": "Inventory Search Result Cell Template",
                                                "id": "pageSettings"
                                            }
                                        }
                                    },
                                    "showCell": {
                                        "desktop": {
                                            "blocks": [
                                                {
                                                    "config": {
                                                        "block": {
                                                            "alignment-col1": "tc",
                                                            "alignment-col2": "tl",
                                                            "columnCount": "2",
                                                            "flexDirection-col1": "column",
                                                            "flexDirection-col2": "row",
                                                            "maxWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "minWidth-col1": {
                                                                "unit": "px",
                                                                "value": "200"
                                                            },
                                                            "paddingLeft-col2": {
                                                                "unit": "px",
                                                                "value": "50"
                                                            }
                                                        },
                                                        "layout": {
                                                            "borderBottomColor": "rgba(221,221,221,1)",
                                                            "borderBottomStyle": "solid",
                                                            "borderBottomWidth": {
                                                                "unit": "px",
                                                                "value": "1"
                                                            },
                                                            "minHeight": {
                                                                "unit": "px",
                                                                "value": "190"
                                                            },
                                                            "paddingBottom": {
                                                                "unit": "px",
                                                                "value": "40"
                                                            },
                                                            "textAlign": "center"
                                                        }
                                                    },
                                                    "dataType": "layout",
                                                    "id": `${Name.Block.Columns}-showSearchResultsCell-${new Date().getTime()}`,
                                                    "type": {
                                                        "value": Name.Block.Columns
                                                    },
                                                    "blocks": [
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "borderRadius": {
                                                                            "unit": "px",
                                                                            "value": "3"
                                                                        },
                                                                        "borderTopStyle": "solid",
                                                                        "borderTopWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderTopColor": "#bbbbbb",
                                                                        "borderBottomColor": "#bbbbbb",
                                                                        "borderLeftColor": "#bbbbbb",
                                                                        "borderRightColor": "#bbbbbb",
                                                                        "borderBottomStyle": "solid",
                                                                        "borderLeftStyle": "solid",
                                                                        "borderRightStyle": "solid",
                                                                        "borderBottomWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderLeftWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        },
                                                                        "borderRightWidth": {
                                                                            "unit": "px",
                                                                            "value": "1"
                                                                        }
                                                                    },
                                                                    "layout": {
                                                                        "isCropped": false,
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "150"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Image.Show}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Image.Show
                                                                }
                                                            }
                                                        ],
                                                        [
                                                            {
                                                                "config": {
                                                                    "block": {
                                                                        "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Show]()
                                                                    },
                                                                    "layout": {
                                                                        "maxHeight": {
                                                                            "unit": "px",
                                                                            "value": "143"
                                                                        }
                                                                    }
                                                                },
                                                                "id": `${Name.Block.SearchResult.Cell.Text.Show}-${new Date().getTime()}`,
                                                                "type": {
                                                                    "value": Name.Block.SearchResult.Cell.Text.Show
                                                                }
                                                            }
                                                        ]
                                                    ]
                                                }
                                            ],
                                            "page": {
                                                "config": {
                                                    "block": {},
                                                    "layout": {}
                                                },
                                                "type": PageType.Content.SearchResultCell.Exhibition,
                                                "display": "Exhibition Search Result Cell Template",
                                                "id": "pageSettings"
                                            }
                                        }
                                    }
                                },
                                "tabs": {
                                    "useTabs": true,
                                    "alignmentContainer": "center",
                                    "alignment": "center",
                                    "paddingBottom": {
                                        "unit": "px",
                                        "value": "10"
                                    },
                                    "borderBottomStyle": "solid",
                                    "borderBottomWidth": {
                                        "unit": "px",
                                        "value": "1"
                                    },
                                    "borderBottomColor": "rgba(220,220,220,1)",
                                    "marginBottom": {
                                        "unit": "px",
                                        "value": "30"
                                    }
                                },
                                "layout": {
                                    "paddingBottom": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "textAlign": "center"
                                }
                            },
                            "id": `${Name.Block.SearchResult.List}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.SearchResult.List
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {}
                        },
                        "type": PageType.SearchResults,
                        "display": "Search Results Template",
                        "id": "pageSettings"
                    }
                }
            }
        }
    }
}

Defaults.Block[Name.Block.Artist.List] = {
    GridCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "source": "cover"
                        },
                        "layout": {
                            "alignItems": "center",
                            "isCropped": true
                        }
                    },
                    "id": `${Name.Block.Artist.Cell.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Artist.Cell.Text](undefined, 'center')
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "16"
                            }
                        }
                    },
                    "id": `${Name.Block.Artist.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.ArtistCell.Grid,
                "display": "Artist Grid Cell Template",
                "id": "pageSettings"
            }
        }
    },
    ListCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Artist.Cell.Text]('font-weight:bold;')
                        },
                        "layout": {}
                    },
                    "id": `${Name.Block.Artist.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.ArtistCell.List,
                "display": "Artist List Cell Template",
                "id": "pageSettings"
            }
        }
    },
    ListPreviewCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "source": "cover"
                        },
                        "layout": {
                            "alignItems": "center",
                            "isCropped": true
                        }
                    },
                    "id": `${Name.Block.Artist.Cell.Image}-preview-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Artist.Cell.Text](undefined, 'center')
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "16"
                            }
                        }
                    },
                    "id": `${Name.Block.Artist.Cell.Text}-preview-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.ArtistCell.ListPreview,
                "display": "Artist List Preview Template",
                "id": "pageSettings"
            }
        }
    },
    SlideshowCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "source": "cover"
                        },
                        "layout": {
                            "alignItems": "center",
                            "isCropped": true
                        }
                    },
                    "id": `${Name.Block.Artist.Cell.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Artist.Cell.Text](undefined, 'center')
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "16"
                            }
                        }
                    },
                    "id": `${Name.Block.Artist.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.ArtistCell.Slideshow,
                "display": "Artist Slideshow Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.Artist.Signup.Container] = {
    "desktop": {
        "blocks": [
            {
                "config": {
                    "block": {
                        "type": "Name",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        }
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Artist.Signup.Input.Name}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Artist.Signup.Input.Name
                }
            },
            {
                "config": {
                    "block": {
                        "type": "Email",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        }
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Artist.Signup.Input.Email}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Artist.Signup.Input.Email
                }
            },
            {
                "config": {
                    "block": {
                        "buttonDesign": Kit.Context.Button.Primary,
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'FOLLOW ARTIST' })
                    },
                    "hover": {},
                    "layout": {
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Artist.Signup.SubmitButtonV2}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Artist.Signup.SubmitButtonV2
                }
            },
            {
                "config": {
                    "block": {
                        "design": Defaults.Block.ErrorMessage()
                    },
                    "layout": {
                        "paddingTop": {
                            "value": "10",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Artist.Signup.ErrorMessage}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Artist.Signup.ErrorMessage
                }
            },
            {
                "config": {
                    "block": {
                        "design": Layout.wrapTextForEditor({ text: 'You are now following this artist.' })
                    },
                    "layout": {
                        "paddingTop": {
                            "value": "10",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Artist.Signup.SuccessMessage}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Artist.Signup.SuccessMessage
                }
            }
        ],
        "page": {
            "config": {},
            "type": PageType.Form.ArtistSignup,
            "display": "Artist Signup Form",
            "id": "pageSettings"
        }
    }
};

Defaults.Block[Name.Block.Blog.List] = {
    Cell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "alignment-col1": "tl",
                            "alignment-col2": "tl",
                            "columnCount": "2",
                            "flexDirection-col1": "row",
                            "flexDirection-col2": "column",
                            "maxWidth-col1": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "maxWidth-col2": {
                                "unit": "%",
                                "value": "66.67"
                            },
                            "minWidth-col1": {
                                "unit": "%",
                                "value": "33.33"
                            },
                            "minWidth-col2": {
                                "unit": "%",
                                "value": "66.67"
                            },
                            "paddingLeft-col2": {
                                "unit": "px",
                                "value": "20"
                            }
                        },
                        "layout": {
                            "textAlign": "center"
                        }
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-blogcell-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Columns
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "layout": {
                                        "isCropped": true
                                    }
                                },
                                "id": `${Name.Block.Blog.Cell.Image}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Blog.Cell.Image
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "block": {
                                        "design": Defaults.Block[Name.Block.Blog.Cell.Text]
                                    },
                                    "layout": {}
                                },
                                "id": `${Name.Block.Blog.Cell.Text}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Blog.Cell.Text
                                }
                            }
                        ]
                    ]
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.BlogCell,
                "display": "Blog Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Kit.Type.Button] = {
    [Kit.Context.Button.Primary]: {
        "config": {
            "block": {
                "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="color:rgba(0,0,0,1);"`, token: Token.ButtonText }),
                "backgroundColor": "rgba(255,255,255,1)",
                "borderRadius": {
                    "value": "",
                    "unit": "px"
                },
                "alignment": "center",
                "typeStyle": Kit.Context.Global.Header6,
                "style": "color:rgba(0,0,0,1);"
            },
            "hover": {
                "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="color:rgba(0,0,0,1);"`, token: Token.ButtonText }),
                "alignment": "center",
                "typeStyle": Kit.Context.Global.Header6,
                "style": "color:rgba(0,0,0,1);"
            },
            "layout": {
                "paddingLeft": {
                    "value": "10",
                    "unit": "px"
                },
                "paddingRight": {
                    "value": "10",
                    "unit": "px"
                },
                "height": {
                    "value": "40",
                    "unit": "px"
                },
                "alignment": "center"
            }
        },
        "id": `${Name.Block.ButtonV3}-${new Date().getTime()}`,
        "type": {
            "value": Name.Block.ButtonV3
        }
    },
    [Kit.Context.Button.Secondary]: {
        "config": {
            "block": {
                "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="color:rgba(255,255,255,1);"`, token: Token.ButtonText }),
                "backgroundColor": "rgba(0,0,0,1)",
                "borderRadius": {
                    "value": "",
                    "unit": "px"
                },
                "alignment": "center",
                "typeStyle": Kit.Context.Global.Header6,
                "style": "color:rgba(255,255,255,1);"
            },
            "hover": {
                "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="color:rgba(255,255,255,1);"`, token: Token.ButtonText }),
                "alignment": "center",
                "typeStyle": Kit.Context.Global.Header6,
                "style": "color:rgba(255,255,255,1);"
            },
            "layout": {
                "paddingLeft": {
                    "value": "10",
                    "unit": "px"
                },
                "paddingRight": {
                    "value": "10",
                    "unit": "px"
                },
                "height": {
                    "value": "40",
                    "unit": "px"
                },
                "alignment": "center"
            }
        },
        "id": `${Name.Block.ButtonV3}-${new Date().getTime()}`,
        "type": {
            "value": Name.Block.ButtonV3
        }
    }
}

Defaults.Block[Name.Block.Cart.CardForm.Container] = {
    "desktop": {
        "blocks": [
            {
                "config": {
                    "block": {
                        "columnCount": "2",
                        "flexDirection-col1": "column",
                        "alignment-col1": "tl",
                        "flexDirection-col2": "column",
                        "alignment-col2": "tl",
                        "paddingLeft-col2": {
                            "unit": "px",
                            "value": "10"
                        },
                        "paddingRight-col1": {
                            "unit": "px",
                            "value": "10"
                        }
                    },
                    "layout": {
                        "textAlign": "center",
                        "backgroundPosition": "mc",
                        "backgroundSize": "contain",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false
                    }
                },
                "dataType": "layout",
                "id": `${Name.Block.Columns}-1-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Columns
                },
                "blocks": [
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "FirstName"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.FirstName}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.FirstName
                            }
                        }
                    ],
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "LastName"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.LastName}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.LastName
                            }
                        }
                    ]
                ]
            },
            {
                "config": {
                    "block": {
                        "columnCount": "2",
                        "flexDirection-col1": "column",
                        "alignment-col1": "tl",
                        "flexDirection-col2": "column",
                        "alignment-col2": "tl",
                        "paddingLeft-col2": {
                            "unit": "px",
                            "value": "10"
                        },
                        "paddingRight-col1": {
                            "unit": "px",
                            "value": "10"
                        }
                    },
                    "layout": {
                        "textAlign": "center",
                        "backgroundPosition": "mc",
                        "backgroundSize": "contain",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false
                    }
                },
                "dataType": "layout",
                "id": `${Name.Block.Columns}-2-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Columns
                },
                "blocks": [
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "Email"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.Email}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.Email
                            }
                        }
                    ],
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "Phone"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.Phone}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.Phone
                            }
                        }
                    ]
                ]
            },
            {
                "config": {
                    "block": {
                        "columnCount": "2",
                        "flexDirection-col1": "column",
                        "alignment-col1": "tl",
                        "flexDirection-col2": "column",
                        "alignment-col2": "tl",
                        "paddingLeft-col2": {
                            "unit": "px",
                            "value": "10"
                        },
                        "paddingRight-col1": {
                            "unit": "px",
                            "value": "10"
                        }
                    },
                    "layout": {
                        "textAlign": "center",
                        "backgroundPosition": "mc",
                        "backgroundSize": "contain",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false
                    }
                },
                "dataType": "layout",
                "id": `${Name.Block.Columns}-3-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Columns
                },
                "blocks": [
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "AddressLineOne"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.BillingAddress.AddressLine1}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.BillingAddress.AddressLine1
                            }
                        }
                    ],
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "AddressLineTwo"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.BillingAddress.AddressLine2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.BillingAddress.AddressLine2
                            }
                        }
                    ]
                ]
            },
            {
                "config": {
                    "block": {
                        "columnCount": "2",
                        "flexDirection-col1": "column",
                        "alignment-col1": "tl",
                        "flexDirection-col2": "column",
                        "alignment-col2": "tl",
                        "paddingLeft-col2": {
                            "unit": "px",
                            "value": "10"
                        },
                        "paddingRight-col1": {
                            "unit": "px",
                            "value": "10"
                        }
                    },
                    "layout": {
                        "textAlign": "center",
                        "backgroundPosition": "mc",
                        "backgroundSize": "contain",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false
                    }
                },
                "dataType": "layout",
                "id": `${Name.Block.Columns}-4-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Columns
                },
                "blocks": [
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "City"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.BillingAddress.City}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.BillingAddress.City
                            }
                        }
                    ],
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "State"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.BillingAddress.State}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.BillingAddress.State
                            }
                        }
                    ]
                ]
            },
            {
                "config": {
                    "block": {
                        "columnCount": "2",
                        "flexDirection-col1": "column",
                        "alignment-col1": "tl",
                        "flexDirection-col2": "column",
                        "alignment-col2": "tl",
                        "paddingLeft-col2": {
                            "unit": "px",
                            "value": "10"
                        },
                        "paddingRight-col1": {
                            "unit": "px",
                            "value": "10"
                        }
                    },
                    "layout": {
                        "textAlign": "center",
                        "backgroundPosition": "mc",
                        "backgroundSize": "contain",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false
                    }
                },
                "dataType": "layout",
                "id": `${Name.Block.Columns}-5-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Columns
                },
                "blocks": [
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "Zip"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.BillingAddress.Zip}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.BillingAddress.Zip
                            }
                        }
                    ],
                    [
                        {
                            "config": {
                                "block": {
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    },
                                    "type": "Country"
                                },
                                "layout": {
                                    "marginBottom": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.CardForm.Input.BillingAddress.Country}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.CardForm.Input.BillingAddress.Country
                            }
                        }
                    ]
                ]
            },
            {
                "config": {
                    "block": {
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        },
                        "type": "Notes"
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Cart.CardForm.Input.Notes}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Cart.CardForm.Input.Notes
                }
            },
            Defaults.Block[Name.Block.Cart.StripeElements],
            {
                "config": {
                    "block": {
                        "design": Defaults.Block.ErrorMessage()
                    },
                    "layout": {
                        "paddingBottom": {
                            "value": "5",
                            "unit": "px"
                        },
                        "paddingTop": {
                            "value": "15",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Cart.CardForm.ErrorMessage}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Cart.CardForm.ErrorMessage
                }
            }
        ],
        "page": {
            "config": {},
            "type": PageType.Form.Cart.Card,
            "display": "Card Form",
            "id": "pageSettings"
        }
    }
};

Defaults.Block[Name.Block.Cart.PromoCode.Container] = {
    "desktop": {
        "blocks": [
            {
                "config": {
                    "block": {
                        "columnCount": "2",
                        "flexDirection-col1": "row",
                        "alignment-col1": "ml",
                        "flexDirection-col2": "row",
                        "alignment-col2": "ml",
                        "minWidth-col2": {
                            "unit": "%",
                            "value": "58"
                        }
                    },
                    "layout": {
                        "textAlign": "center",
                        "backgroundPosition": "mc",
                        "backgroundSize": "contain",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false
                    }
                },
                "dataType": "layout",
                "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Columns
                },
                "blocks": [
                    [],
                    [
                        {
                            "config": {
                                "block": {
                                    "type": "code",
                                    "borderRadius": {
                                        "value": "2",
                                        "unit": "px"
                                    }
                                },
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "57",
                                        "unit": "%"
                                    },
                                    "alignment": "center",
                                    "marginRight": {
                                        "unit": "px",
                                        "value": "10"
                                    }
                                }
                            },
                            "id": `${Name.Block.Cart.PromoCode.Input.Code}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.PromoCode.Input.Code
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Primary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'APPLY' })
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "unit": "%",
                                        "value": "43"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Cart.PromoCode.SubmitButtonV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Cart.PromoCode.SubmitButtonV2
                            }
                        }
                    ]
                ]
            },
            {
                "config": {
                    "block": {
                        "design": Defaults.Block.ErrorMessage()
                    },
                    "layout": {
                        "paddingTop": {
                            "value": "20",
                            "unit": "px"
                        },
                        "alignment": "right",
                        "maxWidth": {
                            "unit": "%",
                            "value": "58"
                        }
                    }
                },
                "id": `${Name.Block.Cart.PromoCode.ErrorMessage}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Cart.PromoCode.ErrorMessage
                }
            }
        ],
        "page": {
            "config": {},
            "type": PageType.Form.Cart.PromoCode,
            "display": "Promo Code Form",
            "id": "pageSettings"
        }

    }
};

Defaults.Block[Name.Block.Contact.Form.Container] = {
    "desktop": {
        "blocks": [
            {
                "config": {
                    "block": {
                        "type": "Name",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        }
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Contact.Form.Input.Name}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.Input.Name
                }
            },
            {
                "config": {
                    "block": {
                        "type": "Email",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        }
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Contact.Form.Input.Email}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.Input.Email
                }
            },
            {
                "config": {
                    "block": {
                        "type": "Phone",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        }
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Contact.Form.Input.Phone}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.Input.Phone
                }
            },
            {
                "config": {
                    "block": {
                        "type": "Subject",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        }
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Contact.Form.Input.Subject}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.Input.Subject
                }
            },
            {
                "config": {
                    "block": {
                        "type": "Message",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        },
                        "resize": true,
                        "rows": "6"
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingBottom": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingTop": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Contact.Form.Input.Message}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.Input.Message
                }
            },
            {
                "config": {
                    "block": {
                        "buttonDesign": Kit.Context.Button.Primary,
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'SEND MESSAGE' })
                    },
                    "hover": {},
                    "layout": {
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "",
                            "unit": "%"
                        },
                        "alignment": "left"
                    }
                },
                "id": `${Name.Block.Contact.Form.SubmitButtonV2}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.SubmitButtonV2
                }
            },
            {
                "config": {
                    "block": {
                        "design": Defaults.Block.ErrorMessage()
                    },
                    "layout": {
                        "paddingTop": {
                            "value": "10",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Contact.Form.ErrorMessage}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.ErrorMessage
                }
            },
            {
                "config": {
                    "block": {
                        "design": Layout.wrapTextForEditor({ text: 'A representative will be in touch soon!' })
                    },
                    "layout": {
                        "paddingTop": {
                            "value": "10",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.Contact.Form.SuccessMessage}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Contact.Form.SuccessMessage
                }
            }
        ],
        "page": {
            "config": {},
            "type": PageType.Form.Contact,
            "display": "Contact Form",
            "id": "pageSettings"
        }
    }
};

Defaults.Block[Name.Block.Footer.SubscribeForm.Container] = Defaults.subscribeForm(PageType.Form.FooterSubscribe);

Defaults.Block[Name.Block.Header.SearchBar.Container] = {
    "desktop": {
        "blocks": [
            {
                "config": {
                    "block": {
                        "columnCount": "1",
                        "flexDirection-col1": "row",
                        "alignment-col1": "tl"
                    },
                    "layout": {
                        "textAlign": "center",
                        "backgroundPosition": "mc",
                        "backgroundSize": "contain",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false,
                        "paddingTop": {
                            "unit": "px",
                            "value": "15"
                        },
                        "paddingBottom": {
                            "unit": "px",
                            "value": "15"
                        }
                    }
                },
                "dataType": "layout",
                "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.Columns
                },
                "blocks": [
                    [
                        {
                            "config": {
                                "block": {
                                    "type": "q",
                                    "borderRadius": {
                                        "value": "",
                                        "unit": "px"
                                    },
                                    "borderBottomStyle": "solid",
                                    "borderLeftStyle": "none",
                                    "borderRightStyle": "none",
                                    "borderTopStyle": "none",
                                    "borderBottomWidth": {
                                        "unit": "px",
                                        "value": "1"
                                    }
                                },
                                "layout": {
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "width": {
                                        "value": "100",
                                        "unit": "%"
                                    },
                                    "alignment": "center"
                                }
                            },
                            "id": `${Name.Block.Header.SearchBar.Input.Search}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Header.SearchBar.Input.Search
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "buttonDesign": Kit.Context.Button.Primary,
                                    "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'SEARCH' })
                                },
                                "hover": {},
                                "layout": {
                                    "paddingLeft": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "paddingRight": {
                                        "value": "10",
                                        "unit": "px"
                                    },
                                    "height": {
                                        "value": "40",
                                        "unit": "px"
                                    },
                                    "alignment": "center",
                                    "marginLeft": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Header.SearchBar.SubmitButtonV2}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Header.SearchBar.SubmitButtonV2
                            }
                        }
                    ]
                ]
            }
        ],
        "page": {
            "config": {
                "block": {}
            },
            "type": PageType.Form.HeaderSearch,
            "display": "Search Bar Form",
            "id": "pageSettings"
        }
    }
};

Defaults.Block[Name.Block.InquireForm.Container] = (config) => {
    const bodyColor = (config.colors && config.colors.bodyBackground) || ''
    const bodyTextColor = (config.colors && config.colors.bodyText) || ''
    return {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "type": "Name",
                            "borderRadius": {
                                "value": "2",
                                "unit": "px"
                            }
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "paddingLeft": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingRight": {
                                "value": "10",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.InquireForm.Input.Name}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.InquireForm.Input.Name
                    }
                },
                {
                    "config": {
                        "block": {
                            "type": "Email",
                            "borderRadius": {
                                "value": "2",
                                "unit": "px"
                            }
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "paddingLeft": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingRight": {
                                "value": "10",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.InquireForm.Input.Email}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.InquireForm.Input.Email
                    }
                },
                {
                    "config": {
                        "block": {
                            "type": "Phone",
                            "borderRadius": {
                                "value": "2",
                                "unit": "px"
                            }
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "paddingLeft": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingRight": {
                                "value": "10",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.InquireForm.Input.Phone}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.InquireForm.Input.Phone
                    }
                },
                {
                    "config": {
                        "block": {
                            "type": "Message",
                            "borderRadius": {
                                "value": "2",
                                "unit": "px"
                            },
                            "resize": true,
                            "rows": "6"
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "paddingBottom": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingLeft": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingRight": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingTop": {
                                "value": "10",
                                "unit": "px"
                            },
                            "height": {
                                "value": "",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.InquireForm.Input.Message}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.InquireForm.Input.Message
                    }
                },
                {
                    "config": {
                        "block": {
                            "buttonDesign": Kit.Context.Button.Primary,
                            "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'INQUIRE' })
                        },
                        "hover": {},
                        "layout": {
                            "marginTop": {
                                "value": "20",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.InquireForm.SubmitButtonV2}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.InquireForm.SubmitButtonV2
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block.ErrorMessage()
                        },
                        "layout": {
                            "paddingTop": {
                                "value": "10",
                                "unit": "px"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.InquireForm.ErrorMessage}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.InquireForm.ErrorMessage
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Layout.wrapTextForEditor({ text: 'Message Sent' })
                        },
                        "layout": {
                            "paddingTop": {
                                "value": "10",
                                "unit": "px"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.InquireForm.SuccessMessage}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.InquireForm.SuccessMessage
                    }
                }
            ],
            "page": {
                "config": {},
                "type": PageType.Form.Inquire,
                "display": "Inquire Form",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.Inventory.ListV3] = {
    GridCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "layout": {
                            "isCropped": false
                        }
                    },
                    "id": `${Name.Block.Inventory.Cell.Image}-grid-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Inventory.Cell.Text]
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.InventoryCell.Grid,
                "display": "Inventory Grid Cell Template",
                "id": "pageSettings"
            }
        }
    },
    MediumList: [
        { display: 'Oil', value: 'Oil' },
        { display: 'Mixed Media', value: 'Mixed Media' },
        { display: 'Sculpture', value: 'Sculpture' },
        { display: 'Acrylic', value: 'Acrylic' },
        { display: 'Photography', value: 'Photography' },
        { display: 'Paper', value: 'Paper' }
    ],
    SlideshowCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "layout": {
                            "alignment": "mc",
                            "maxHeight": {
                                "unit": "%",
                                "value": "67"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Cell.SlideshowImage}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.SlideshowImage
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Inventory.Cell.Text]
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.InventoryCell.SlideshowV2,
                "display": "Inventory Slideshow Cell Template",
                "id": "pageSettings"
            }
        }
    },
    Tabs: (color, extraStyle) => Layout.wrapTextForEditor({ text: `{${Token.TabTitle}}`, textExtras: `style="${color ? `color:${color};` : ''}font-size:11px;letter-spacing:1.2px;text-transform:uppercase;${extraStyle || ''}"`, token: Token.TabTitle }),
    WaterfallCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "layout": {}
                    },
                    "id": `${Name.Block.Inventory.Cell.Image}-waterfall-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Inventory.Cell.Text]
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.InventoryCell.Waterfall,
                "display": "Inventory Waterfall Cell Template",
                "id": "pageSettings"
            }
        }
    }
}

Defaults.Block[Name.Block.Inventory.ListV4] = {
    GridCell: Defaults.Block[Name.Block.Inventory.ListV3].GridCell,
    MediumList: Defaults.Block[Name.Block.Inventory.ListV3].MediumList,
    SlideshowCell: Defaults.Block[Name.Block.Inventory.ListV3].SlideshowCell,
    Tabs: (color, extraStyle) => Layout.wrapTextForEditor({ text: `{${Token.TabTitle}}`, textExtras: `style="${color ? `color:${color};` : ''}${extraStyle || ''}"`, token: Token.TabTitle }),
    WaterfallCell: Defaults.Block[Name.Block.Inventory.ListV3].WaterfallCell
};

Defaults.Block[Name.Block.Inventory.ListV2] = {
    GridCell: Defaults.Block[Name.Block.Inventory.ListV3].GridCell,
    MediumList: Defaults.Block[Name.Block.Inventory.ListV3].MediumList,
    SlideshowCell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "layout": {}
                    },
                    "id": `${Name.Block.Inventory.Cell.Image}-slideshow-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Inventory.Cell.Text]
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.InventoryCell.Slideshow,
                "display": "Inventory Slideshow Cell Template",
                "id": "pageSettings"
            }
        }
    },
    Tabs: Defaults.Block[Name.Block.Inventory.ListV3].Tabs,
    WaterfallCell: Defaults.Block[Name.Block.Inventory.ListV3].WaterfallCell
};

Defaults.Block[Name.Block.Inventory.RecentlyViewed.List] = {
    Cell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "layout": {
                            "height": {
                                "value": "180",
                                "unit": "px"
                            },
                            "isCropped": false
                        }
                    },
                    "id": `${Name.Block.Inventory.RecentlyViewed.Cell.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.RecentlyViewed.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Inventory.RecentlyViewed.Cell.Text]()
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "textAlign": "center",
                            "marginTop": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "id": `${Name.Block.Inventory.RecentlyViewed.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.RecentlyViewed.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.RecentlyViewedCell,
                "display": "Recently Viewed Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.OfferForm.Container] = (config) => {
    const bodyColor = (config.colors && config.colors.bodyBackground) || ''
    const bodyTextColor = (config.colors && config.colors.bodyText) || ''
    return {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, tagExtras: `style="text-align:center;"`, text: 'Offer (Fixed or Percent Off)' })
                        },
                        "container": {
                            "animation": "0"
                        },
                        "layout": {
                            "paddingBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Text}-offer-1-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Text
                    }
                },
                {
                    "config": {
                        "block": {
                            "columnCount": "2",
                            "flexDirection-col1": "column",
                            "alignment-col1": "tl",
                            "flexDirection-col2": "column",
                            "alignment-col2": "tl",
                            "paddingLeft-col2": {
                                "unit": "px",
                                "value": "10"
                            },
                            "paddingRight-col1": {
                                "unit": "px",
                                "value": "10"
                            }
                        },
                        "layout": {
                            "textAlign": "center",
                            "backgroundPosition": "mc",
                            "backgroundSize": "contain",
                            "backgroundRepeatX": false,
                            "backgroundRepeatY": false,
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-offer-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Columns
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "block": {
                                        "type": "PriceFixed",
                                        "symbolLeft": {
                                            "value": "10",
                                            "unit": "px"
                                        },
                                        "borderRadius": {
                                            "value": "2",
                                            "unit": "px"
                                        }
                                    },
                                    "layout": {
                                        "marginBottom": {
                                            "value": "20",
                                            "unit": "px"
                                        },
                                        "paddingLeft": {
                                            "value": "25",
                                            "unit": "px"
                                        },
                                        "paddingRight": {
                                            "value": "10",
                                            "unit": "px"
                                        },
                                        "height": {
                                            "value": "40",
                                            "unit": "px"
                                        },
                                        "width": {
                                            "value": "100",
                                            "unit": "%"
                                        },
                                        "alignment": "center"
                                    }
                                },
                                "id": `${Name.Block.OfferForm.Input.PriceFixed}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.OfferForm.Input.PriceFixed
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "block": {
                                        "type": "PricePercent",
                                        "symbolRight": {
                                            "value": "10",
                                            "unit": "px"
                                        },
                                        "borderRadius": {
                                            "value": "2",
                                            "unit": "px"
                                        }
                                    },
                                    "layout": {
                                        "marginBottom": {
                                            "value": "20",
                                            "unit": "px"
                                        },
                                        "paddingLeft": {
                                            "value": "10",
                                            "unit": "px"
                                        },
                                        "paddingRight": {
                                            "value": "20",
                                            "unit": "px"
                                        },
                                        "height": {
                                            "value": "40",
                                            "unit": "px"
                                        },
                                        "width": {
                                            "value": "100",
                                            "unit": "%"
                                        },
                                        "alignment": "center"
                                    }
                                },
                                "id": `${Name.Block.OfferForm.Input.PricePercent}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.OfferForm.Input.PricePercent
                                }
                            }
                        ]
                    ]
                },
                {
                    "config": {
                        "block": {
                            "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, tagExtras: `style="text-align:center;"`, text: 'Contact Information' })
                        },
                        "container": {
                            "animation": "0"
                        },
                        "layout": {
                            "paddingBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Text}-offer-2-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Text
                    }
                },
                {
                    "config": {
                        "block": {
                            "type": "Name",
                            "borderRadius": {
                                "value": "2",
                                "unit": "px"
                            }
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "paddingLeft": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingRight": {
                                "value": "10",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.OfferForm.Input.Name}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.OfferForm.Input.Name
                    }
                },
                {
                    "config": {
                        "block": {
                            "type": "Email",
                            "borderRadius": {
                                "value": "2",
                                "unit": "px"
                            }
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "paddingLeft": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingRight": {
                                "value": "10",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.OfferForm.Input.Email}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.OfferForm.Input.Email
                    }
                },
                {
                    "config": {
                        "block": {
                            "type": "Phone",
                            "borderRadius": {
                                "value": "2",
                                "unit": "px"
                            }
                        },
                        "layout": {
                            "marginBottom": {
                                "value": "20",
                                "unit": "px"
                            },
                            "paddingLeft": {
                                "value": "10",
                                "unit": "px"
                            },
                            "paddingRight": {
                                "value": "10",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.OfferForm.Input.Phone}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.OfferForm.Input.Phone
                    }
                },
                {
                    "config": {
                        "block": {
                            "buttonDesign": Kit.Context.Button.Primary,
                            "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'MAKE AN OFFER' })
                        },
                        "hover": {},
                        "layout": {
                            "marginTop": {
                                "value": "20",
                                "unit": "px"
                            },
                            "height": {
                                "value": "40",
                                "unit": "px"
                            },
                            "width": {
                                "value": "100",
                                "unit": "%"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.OfferForm.SubmitButtonV2}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.OfferForm.SubmitButtonV2
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block.ErrorMessage()
                        },
                        "layout": {
                            "paddingTop": {
                                "value": "10",
                                "unit": "px"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.OfferForm.ErrorMessage}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.OfferForm.ErrorMessage
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Layout.wrapTextForEditor({ text: 'Offer Sent' })
                        },
                        "layout": {
                            "paddingTop": {
                                "value": "10",
                                "unit": "px"
                            },
                            "alignment": "center"
                        }
                    },
                    "id": `${Name.Block.OfferForm.SuccessMessage}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.OfferForm.SuccessMessage
                    }
                }
            ],
            "page": {
                "config": {},
                "type": PageType.Form.Offer,
                "display": "Offer Form",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.PasswordForm.Container] = {
    "desktop": {
        "blocks": [
            {
                "config": {
                    "block": {
                        "type": "Password",
                        "borderRadius": {
                            "value": "2",
                            "unit": "px"
                        }
                    },
                    "layout": {
                        "marginBottom": {
                            "value": "20",
                            "unit": "px"
                        },
                        "paddingLeft": {
                            "value": "10",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "10",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.PasswordForm.Input.Password}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.PasswordForm.Input.Password
                }
            },
            {
                "config": {
                    "block": {
                        "buttonDesign": Kit.Context.Button.Primary,
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header6, tagExtras: `style="text-align:center;"`, text: 'Continue' })
                    },
                    "hover": {},
                    "layout": {
                        "marginTop": {
                            "value": "20",
                            "unit": "px"
                        },
                        "height": {
                            "value": "40",
                            "unit": "px"
                        },
                        "width": {
                            "value": "100",
                            "unit": "%"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.PasswordForm.SubmitButton}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.PasswordForm.SubmitButton
                }
            },
            {
                "config": {
                    "block": {
                        "design": Defaults.Block.ErrorMessage()
                    },
                    "layout": {
                        "paddingTop": {
                            "value": "10",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.PasswordForm.ErrorMessage}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.PasswordForm.ErrorMessage
                }
            }
        ],
        "page": {
            "config": {},
            "type": PageType.Form.Password,
            "display": "Password Form",
            "id": "pageSettings"
        }
    }
};

Defaults.Block[Kit.Type.Presentation] = {
    getWrappedValue: (value, context, theme = {}) => {
        const _value = value || '';
        switch (context) {
            case Kit.Context.Presentation.Company:
                return Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: _value, textExtras: `style="${theme.color ? `color:${theme.color.main};` : ''}line-height:100%;"` });
            case Kit.Context.Presentation.Description:
                return Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header3, text: _value, textExtras: `style="${theme.color ? `color:${theme.color.description};` : ''}"` });
            case Kit.Context.Presentation.Subtitle:
                return `<h2 class="h1"><span data-heading="h1" style="${theme.color ? `color:${theme.color.secondary};` : ''}">${_value}</span></h2>`
            case Kit.Context.Presentation.Title:
                return `<h1 class="h1"><span data-heading="h1" style="${theme.color ? `color:${theme.color.main};` : ''}font-weight:500;">${_value}</span></h1>`
            default:
                return '';
        }
    },
    getTheme: (themeConfig = {}) => {
        let color, fontFamily;
        switch (themeConfig.color) {
            case 'dark':
                color = { background: '#000000', backgroundAlt: '#0e0f10', border: '#333333', border2: '#777777', button: '#cccccc', description: '#cccccc', main: '#efefef', primary: '#00b1ff', secondary: '#6f777f' };
                break;
            default:
                color = { background: '#ffffff', backgroundAlt: '#f8f9fa', border: '#ced4da', border2: '#e9ecef', button: '#222529', description: '#333333', main: '#0e0f10', primary: '#00b1ff', secondary: '#6f777f' };
                break;
        }
        switch (themeConfig.font) {
            case 'serif':
                fontFamily = `'Times New Roman',serif`;
                break;
            default:
                fontFamily = `'Inter',arial,sans-serif`;
                break;
        }
        return { color, fontFamily };
    },

    [Kit.Type.Button]: {
        [Kit.Context.Button.Primary]: (themeConfig = {}) => {
            const theme = Defaults.Block[Kit.Type.Presentation].getTheme(themeConfig);
            return {
                "config": {
                    "block": {
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="color:rgba(255,255,255,1);font-weight:500;"`, token: Token.ButtonText }),
                        "backgroundColor": theme.color.primary,
                        "borderRadius": {
                            "value": "8",
                            "unit": "px"
                        },
                        "alignment": "center",
                        "typeStyle": Kit.Context.Global.Header5,
                        "style": "color:rgba(255,255,255,1);font-weight:500;"
                    },
                    "hover": {
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="color:rgba(255,255,255,1);font-weight:500;"`, token: Token.ButtonText }),
                        "alignment": "center",
                        "typeStyle": Kit.Context.Global.Header5,
                        "style": "color:rgba(255,255,255,1);font-weight:500;"
                    },
                    "layout": {
                        "paddingLeft": {
                            "value": "18",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "18",
                            "unit": "px"
                        },
                        "height": {
                            "value": "36",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.ButtonV3}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.ButtonV3
                }
            }
        },
        [Kit.Context.Button.Secondary]: (themeConfig = {}) => {
            const theme = Defaults.Block[Kit.Type.Presentation].getTheme(themeConfig);
            return {
                "config": {
                    "block": {
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="font-weight:500;"`, token: Token.ButtonText }),
                        "borderRadius": {
                            "value": "8",
                            "unit": "px"
                        },
                        "alignment": "center",
                        "typeStyle": Kit.Context.Global.Header5,
                        "style": "font-weight:500;",
                        "borderTopStyle": "solid",
                        "borderTopWidth": {
                            "unit": "px",
                            "value": "1"
                        },
                        "borderTopColor": theme.color.border,
                        "borderBottomColor": theme.color.border,
                        "borderLeftColor": theme.color.border,
                        "borderRightColor": theme.color.border,
                        "borderBottomStyle": "solid",
                        "borderLeftStyle": "solid",
                        "borderRightStyle": "solid",
                        "borderBottomWidth": {
                            "unit": "px",
                            "value": "1"
                        },
                        "borderLeftWidth": {
                            "unit": "px",
                            "value": "1"
                        },
                        "borderRightWidth": {
                            "unit": "px",
                            "value": "1"
                        }
                    },
                    "hover": {
                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, tagExtras: `style="text-align:center;"`, text: `{${Token.ButtonText}}`, textExtras: `style="font-weight:500;"`, token: Token.ButtonText }),
                        "alignment": "center",
                        "typeStyle": Kit.Context.Global.Header5,
                        "style": "font-weight:500;"
                    },
                    "layout": {
                        "paddingLeft": {
                            "value": "18",
                            "unit": "px"
                        },
                        "paddingRight": {
                            "value": "18",
                            "unit": "px"
                        },
                        "height": {
                            "value": "36",
                            "unit": "px"
                        },
                        "alignment": "center"
                    }
                },
                "id": `${Name.Block.ButtonV3}-${new Date().getTime()}`,
                "type": {
                    "value": Name.Block.ButtonV3
                }
            }
        }
    },
    [Kit.Type.Cell]: {
        [Name.Block.Inventory.ListV4]: {
            GridCell: {
                "desktop": {
                    "blocks": [
                        {
                            "config": {
                                "layout": {
                                    "isCropped": false
                                }
                            },
                            "id": `${Name.Block.Inventory.Cell.Image}-grid-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Inventory.Cell.Image
                            }
                        },
                        {
                            "config": {
                                "block": {
                                    "design": Defaults.Block[Name.Block.Inventory.Cell.Text]
                                },
                                "layout": {
                                    "marginTop": {
                                        "unit": "px",
                                        "value": "20"
                                    }
                                }
                            },
                            "id": `${Name.Block.Inventory.Cell.Text}-${new Date().getTime()}`,
                            "type": {
                                "value": Name.Block.Inventory.Cell.Text
                            }
                        }
                    ],
                    "page": {
                        "config": {
                            "block": {},
                            "layout": {}
                        },
                        "type": PageType.Content.Presentation.InventoryCell.Grid,
                        "display": "Inventory Grid Cell Template",
                        "id": "pageSettings"
                    }
                }
            },
            GridCellConstructor: ({ artist, availability, cta, dimensions, medium, price }, theme = {}) => {
                let text = '';
                if (artist) {
                    text += Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: `{${Token.ArtistName}("before":"","after":"")}`, textExtras: `style="${theme.color ? `color:${theme.color.main};` : ''}font-weight:500;"`, token: Token.ArtistName })
                }
                let textExtras = `${theme.color ? `color:${theme.color.secondary};` : ''}font-weight:500;`;
                text += `<p class="${Kit.Context.Global.Header4}">${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: `{${Token.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;${textExtras}"`, token: Token.Title, wrapWithTag: false })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: `{${Token.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;${textExtras}"`, token: Token.Edition, wrapWithTag: false })}${Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header4, text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;${textExtras}"`, token: Token.Date, wrapWithTag: false })}</p>`;
                const blockConfig = {
                    "desktop": {
                        "blocks": [
                            {
                                "config": {
                                    "layout": {
                                        "isCropped": false
                                    }
                                },
                                "id": `${Name.Block.Inventory.Cell.Image}-grid`,
                                "type": {
                                    "value": Name.Block.Inventory.Cell.Image
                                }
                            },
                            {
                                "config": {
                                    "block": {
                                        "design": text
                                    },
                                    "layout": {
                                        "marginTop": {
                                            "unit": "px",
                                            "value": "24"
                                        }
                                    }
                                },
                                "id": `${Name.Block.Inventory.Cell.Text}-title`,
                                "type": {
                                    "value": Name.Block.Inventory.Cell.Text
                                }
                            }
                        ],
                        "page": {
                            "config": {
                                "block": {},
                                "layout": {}
                            },
                            "type": PageType.Content.Presentation.InventoryCell.Grid,
                            "display": "Inventory Grid Cell",
                            "id": "pageSettings"
                        }
                    }
                }
                const details = [];
                if (medium) {
                    details.push({ text: `{${Token.Medium}("before":"","after":"")}`, token: Token.Medium });
                }
                if (dimensions) {
                    details.push({ text: `{${Token.Dimensions}("before":"","after":"")}`, token: Token.Dimensions });
                    // details.push({ text: `{${Token.AlternateDimensions}("before":"","after":"")}`, token: Token.AlternateDimensions });
                }
                if (price) {
                    details.push({ text: `{${Token.PriceWithoutOverride}("showIfSold":"true","before":"","after":"")}`, token: Token.PriceWithoutOverride });
                }
                if (details.length > 0) {
                    textExtras = `${theme.color ? `color:${theme.color.main};` : ''}line-height:23px;`;
                    let detailText = '';
                    for (let i = 0; i < details.length; i++) {
                        detailText += Layout.wrapTextForEditor({ ...details[i], tag: Kit.Context.Global.Header5, textExtras: `style="${textExtras}"` });
                    }
                    blockConfig.desktop.blocks.push({
                        "config": {
                            "block": {
                                "design": detailText
                            },
                            "layout": {
                                "marginTop": {
                                    "unit": "px",
                                    "value": "15"
                                }
                            }
                        },
                        "id": PrivateView.cellTextId(PrivateView.CellField.Details),
                        "type": {
                            "value": Name.Block.Inventory.Cell.Text
                        }
                    });
                }
                if (availability) {
                    textExtras = `${theme.color ? `color:${theme.color.main};` : ''}line-height:20px;`;
                    blockConfig.desktop.blocks.push({
                        "config": {
                            "block": {
                                "design": Layout.wrapTextForEditor({ text: `{${Token.AvailabilityStatus}("availableLabel":"","unavailableLabel":"","colorAvailable":"","colorUnavailable":"","size":"","showIfAvailable":"false")}`, textExtras: `style="${textExtras}"`, token: Token.AvailabilityStatus })
                            },
                            "layout": {
                                "marginTop": {
                                    "unit": "px",
                                    "value": "12"
                                }
                            }
                        },
                        "id": PrivateView.cellTextId(PrivateView.CellField.Availability),
                        "type": {
                            "value": Name.Block.Inventory.Cell.Text
                        }
                    });
                }
                if (cta?.visible) {
                    blockConfig.desktop.blocks.push({
                        "config": {
                            "block": {
                                "borderTopColor": theme.color?.button,
                                "borderBottomColor": theme.color?.button,
                                "borderLeftColor": theme.color?.button,
                                "borderRightColor": theme.color?.button,
                                "buttonDesign": Kit.Context.Button.Secondary,
                                "buttonType": InventoryCTAButtonType.Inquire,
                                "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: cta.text == undefined ? 'Inquire' : cta.text, textColor: theme.color?.button })
                            },
                            "hover": {},
                            "layout": {
                                "alignment": "left",
                                // "hideOnHold": "true",
                                // "hideOnUnavailable": "true",
                                "marginTop": {
                                    "value": "24",
                                    "unit": "px"
                                },
                                "marginBottom": {
                                    "value": "24",
                                    "unit": "px"
                                }
                            }
                        },
                        "id": PrivateView.ctaId,
                        "type": {
                            "value": Name.Block.Inventory.Button.InquireV3
                        }
                    });
                }
                return blockConfig;
            }
        }
    },
    [Name.Block.InquireForm.Container]: (config, theme) => {
        const inputBlockProps = {
            "borderRadius": {
                "value": "8",
                "unit": "px"
            },
            "borderTopColor": theme.color?.border,
            "borderBottomColor": theme.color?.border,
            "borderLeftColor": theme.color?.border,
            "borderRightColor": theme.color?.border,
            "borderTopStyle": "solid",
            "borderBottomStyle": "solid",
            "borderLeftStyle": "solid",
            "borderRightStyle": "solid",
            "borderTopWidth": {
                "unit": "px",
                "value": "1"
            },
            "borderBottomWidth": {
                "unit": "px",
                "value": "1"
            },
            "borderLeftWidth": {
                "unit": "px",
                "value": "1"
            },
            "borderRightWidth": {
                "unit": "px",
                "value": "1"
            },
            "placeholder": Layout.wrapTextForEditor({ text: '.', textExtras: `style="color:#ffffff00;"` }),
        }
        const inputLayoutProps = {
            "marginBottom": {
                "value": "12",
                "unit": "px"
            },
            "paddingLeft": {
                "value": "12",
                "unit": "px"
            },
            "paddingRight": {
                "value": "12",
                "unit": "px"
            },
            "height": {
                "value": "36",
                "unit": "px"
            },
            "width": {
                "value": "100",
                "unit": "%"
            },
            "alignment": "center"
        };
        const textExtras = `style="line-height:22px;"`
        return {
            "desktop": {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: 'Name', textExtras }),
                            },
                            "container": {
                                "animation": "0"
                            },
                            "layout": {
                                "paddingBottom": {
                                    "value": "4",
                                    "unit": "px"
                                },
                                "textAlign": "center"
                            }
                        },
                        "id": `${Name.Block.Text}-name-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Text
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "type": "Name",
                                ...inputBlockProps
                            },
                            "layout": inputLayoutProps
                        },
                        "id": `${Name.Block.InquireForm.Input.Name}-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.InquireForm.Input.Name
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: 'Email', textExtras }),
                            },
                            "container": {
                                "animation": "0"
                            },
                            "layout": {
                                "paddingBottom": {
                                    "value": "4",
                                    "unit": "px"
                                },
                                "textAlign": "center"
                            }
                        },
                        "id": `${Name.Block.Text}-email-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Text
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "type": "Email",
                                ...inputBlockProps
                            },
                            "layout": inputLayoutProps
                        },
                        "id": `${Name.Block.InquireForm.Input.Email}-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.InquireForm.Input.Email
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "displayText": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header5, text: 'Message', textExtras }),
                            },
                            "container": {
                                "animation": "0"
                            },
                            "layout": {
                                "paddingBottom": {
                                    "value": "4",
                                    "unit": "px"
                                },
                                "textAlign": "center"
                            }
                        },
                        "id": `${Name.Block.Text}-message-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Text
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "type": "Message",
                                "resize": false,
                                "rows": "6",
                                ...inputBlockProps
                            },
                            "layout": {
                                "marginBottom": {
                                    "value": "16",
                                    "unit": "px"
                                },
                                "paddingBottom": {
                                    "value": "8.5",
                                    "unit": "px"
                                },
                                "paddingLeft": {
                                    "value": "12",
                                    "unit": "px"
                                },
                                "paddingRight": {
                                    "value": "12",
                                    "unit": "px"
                                },
                                "paddingTop": {
                                    "value": "8.5",
                                    "unit": "px"
                                },
                                "height": {
                                    "value": "127",
                                    "unit": "px"
                                },
                                "width": {
                                    "value": "100",
                                    "unit": "%"
                                },
                                "alignment": "center"
                            }
                        },
                        "id": `${Name.Block.InquireForm.Input.Message}-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.InquireForm.Input.Message
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "columnCount": "1",
                                "columnWrap": "mobile",
                                "flexDirection-col1": "row",
                                "alignment-col1": "tr"
                            },
                            "layout": {
                                "textAlign": "center",
                                "backgroundPosition": "mc",
                                "backgroundSize": "contain",
                                "backgroundRepeatX": false,
                                "backgroundRepeatY": false
                            }
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-buttons-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "block": {
                                            "buttonDesign": Kit.Context.Button.Secondary,
                                            "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'Cancel' })
                                        },
                                        "hover": {},
                                        "layout": {
                                            "alignment": "right",
                                            "marginRight": {
                                                "unit": "px",
                                                "value": "12"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.InquireForm.CancelButton}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.InquireForm.CancelButton
                                    }
                                },
                                {
                                    "config": {
                                        "block": {
                                            "buttonDesign": Kit.Context.Button.Primary,
                                            "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'Send' })
                                        },
                                        "hover": {},
                                        "layout": {
                                            "alignment": "right"
                                        }
                                    },
                                    "id": `${Name.Block.InquireForm.SubmitButtonV2}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.InquireForm.SubmitButtonV2
                                    }
                                }
                            ]
                        ]
                    },
                    {
                        "config": {
                            "block": {
                                "design": Defaults.Block.ErrorMessage()
                            },
                            "layout": {
                                "paddingTop": {
                                    "value": "12",
                                    "unit": "px"
                                },
                                "alignment": "center"
                            }
                        },
                        "id": `${Name.Block.InquireForm.ErrorMessage}-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.InquireForm.ErrorMessage
                        }
                    },
                    {
                        "config": {
                            "block": {
                                "design": Layout.wrapTextForEditor({ text: 'Message Sent' })
                            },
                            "layout": {
                                "paddingTop": {
                                    "value": "12",
                                    "unit": "px"
                                },
                                "alignment": "center"
                            }
                        },
                        "id": `${Name.Block.InquireForm.SuccessMessage}-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.InquireForm.SuccessMessage
                        }
                    }
                ],
                "page": {
                    "config": {},
                    "type": PageType.Content.Presentation.Form.Inquire,
                    "display": "Inquire Form",
                    "id": "pageSettings"
                }
            }
        }
    }
};

Defaults.Block[Name.Block.Representative.List] = {
    Cell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Representative.Cell.Text]()
                        },
                        "layout": {}
                    },
                    "id": `${Name.Block.Representative.Cell.Text}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Representative.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.RepresentativeCell,
                "display": "Gallery Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.SearchResult.List] = {
    ArtistCell: (config) => {
        return {
            "desktop": {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "alignment-col1": "tc",
                                "alignment-col2": "tl",
                                "columnCount": "2",
                                "flexDirection-col1": "column",
                                "flexDirection-col2": "row",
                                "maxWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "minWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "paddingLeft-col2": {
                                    "unit": "px",
                                    "value": "50"
                                }
                            },
                            "layout": {
                                "borderBottomColor": "rgba(221,221,221,1)",
                                "borderBottomStyle": "solid",
                                "borderBottomWidth": {
                                    "unit": "px",
                                    "value": "1"
                                },
                                "minHeight": {
                                    "unit": "px",
                                    "value": "150"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "textAlign": "center"
                            }
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-artistSearchResultCell-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "block": {
                                            "borderRadius": {
                                                "unit": "px",
                                                "value": "3"
                                            },
                                            "borderTopStyle": "solid",
                                            "borderTopWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderTopColor": "#bbbbbb",
                                            "borderBottomColor": "#bbbbbb",
                                            "borderLeftColor": "#bbbbbb",
                                            "borderRightColor": "#bbbbbb",
                                            "borderBottomStyle": "solid",
                                            "borderLeftStyle": "solid",
                                            "borderRightStyle": "solid",
                                            "borderBottomWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderLeftWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderRightWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            }
                                        },
                                        "layout": {
                                            "isCropped": false,
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "150"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Image.Artist}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Image.Artist
                                    }
                                }
                            ],
                            [
                                {
                                    "config": {
                                        "block": {
                                            "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Artist](config)
                                        },
                                        "layout": {
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "143"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Text.Artist}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Text.Artist
                                    }
                                }
                            ]
                        ]
                    }
                ],
                "page": {
                    "config": {
                        "block": {},
                        "layout": {}
                    },
                    "type": PageType.Content.SearchResultCell.Artist,
                    "display": "Artist Search Result Cell Template",
                    "id": "pageSettings"
                }
            }
        };
    },
    BlogCell: (config) => {
        return {
            "desktop": {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "alignment-col1": "tc",
                                "alignment-col2": "tl",
                                "columnCount": "2",
                                "flexDirection-col1": "column",
                                "flexDirection-col2": "row",
                                "maxWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "minWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "paddingLeft-col2": {
                                    "unit": "px",
                                    "value": "50"
                                }
                            },
                            "layout": {
                                "borderBottomColor": "rgba(221,221,221,1)",
                                "borderBottomStyle": "solid",
                                "borderBottomWidth": {
                                    "unit": "px",
                                    "value": "1"
                                },
                                "minHeight": {
                                    "unit": "px",
                                    "value": "150"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "textAlign": "center"
                            }
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-blogSearchResultCell-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "block": {
                                            "borderRadius": {
                                                "unit": "px",
                                                "value": "3"
                                            },
                                            "borderTopStyle": "solid",
                                            "borderTopWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderTopColor": "#bbbbbb",
                                            "borderBottomColor": "#bbbbbb",
                                            "borderLeftColor": "#bbbbbb",
                                            "borderRightColor": "#bbbbbb",
                                            "borderBottomStyle": "solid",
                                            "borderLeftStyle": "solid",
                                            "borderRightStyle": "solid",
                                            "borderBottomWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderLeftWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderRightWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            }
                                        },
                                        "layout": {
                                            "isCropped": false,
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "150"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Image.Blog}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Image.Blog
                                    }
                                }
                            ],
                            [
                                {
                                    "config": {
                                        "block": {
                                            "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Blog](config)
                                        },
                                        "layout": {
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "143"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Text.Blog}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Text.Blog
                                    }
                                }
                            ]
                        ]
                    }
                ],
                "page": {
                    "config": {
                        "block": {},
                        "layout": {}
                    },
                    "type": PageType.Content.SearchResultCell.Blog,
                    "display": "Blog Search Result Cell Template",
                    "id": "pageSettings"
                }
            }
        };
    },
    InventoryCell: (config) => {
        return {
            "desktop": {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "alignment-col1": "tc",
                                "alignment-col2": "tl",
                                "columnCount": "2",
                                "flexDirection-col1": "column",
                                "flexDirection-col2": "row",
                                "maxWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "minWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "paddingLeft-col2": {
                                    "unit": "px",
                                    "value": "50"
                                }
                            },
                            "layout": {
                                "borderBottomColor": "rgba(221,221,221,1)",
                                "borderBottomStyle": "solid",
                                "borderBottomWidth": {
                                    "unit": "px",
                                    "value": "1"
                                },
                                "minHeight": {
                                    "unit": "px",
                                    "value": "150"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "textAlign": "center"
                            }
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-inventorySearchResultCell-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "block": {
                                            "borderRadius": {
                                                "unit": "px",
                                                "value": "3"
                                            },
                                            "borderTopStyle": "solid",
                                            "borderTopWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderTopColor": "#bbbbbb",
                                            "borderBottomColor": "#bbbbbb",
                                            "borderLeftColor": "#bbbbbb",
                                            "borderRightColor": "#bbbbbb",
                                            "borderBottomStyle": "solid",
                                            "borderLeftStyle": "solid",
                                            "borderRightStyle": "solid",
                                            "borderBottomWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderLeftWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderRightWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            }
                                        },
                                        "layout": {
                                            "isCropped": false,
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "150"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Image.Inventory}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Image.Inventory
                                    }
                                }
                            ],
                            [
                                {
                                    "config": {
                                        "block": {
                                            "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Inventory](config)
                                        },
                                        "layout": {
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "143"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Text.Inventory}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Text.Inventory
                                    }
                                }
                            ]
                        ]
                    }
                ],
                "page": {
                    "config": {
                        "block": {},
                        "layout": {}
                    },
                    "type": PageType.Content.SearchResultCell.Inventory,
                    "display": "Inventory Search Result Cell Template",
                    "id": "pageSettings"
                }
            }
        };
    },
    ShowCell: (config) => {
        return {
            "desktop": {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "alignment-col1": "tc",
                                "alignment-col2": "tl",
                                "columnCount": "2",
                                "flexDirection-col1": "column",
                                "flexDirection-col2": "row",
                                "maxWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "minWidth-col1": {
                                    "unit": "px",
                                    "value": "200"
                                },
                                "paddingLeft-col2": {
                                    "unit": "px",
                                    "value": "50"
                                }
                            },
                            "layout": {
                                "borderBottomColor": "rgba(221,221,221,1)",
                                "borderBottomStyle": "solid",
                                "borderBottomWidth": {
                                    "unit": "px",
                                    "value": "1"
                                },
                                "minHeight": {
                                    "unit": "px",
                                    "value": "150"
                                },
                                "paddingBottom": {
                                    "unit": "px",
                                    "value": "40"
                                },
                                "textAlign": "center"
                            }
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-showSearchResultCell-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "block": {
                                            "borderRadius": {
                                                "unit": "px",
                                                "value": "3"
                                            },
                                            "borderTopStyle": "solid",
                                            "borderTopWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderTopColor": "#bbbbbb",
                                            "borderBottomColor": "#bbbbbb",
                                            "borderLeftColor": "#bbbbbb",
                                            "borderRightColor": "#bbbbbb",
                                            "borderBottomStyle": "solid",
                                            "borderLeftStyle": "solid",
                                            "borderRightStyle": "solid",
                                            "borderBottomWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderLeftWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            },
                                            "borderRightWidth": {
                                                "unit": "px",
                                                "value": "1"
                                            }
                                        },
                                        "layout": {
                                            "isCropped": false,
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "150"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Image.Show}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Image.Show
                                    }
                                }
                            ],
                            [
                                {
                                    "config": {
                                        "block": {
                                            "design": Defaults.Block[Name.Block.SearchResult.Cell.Text.Show](config)
                                        },
                                        "layout": {
                                            "maxHeight": {
                                                "unit": "px",
                                                "value": "143"
                                            }
                                        }
                                    },
                                    "id": `${Name.Block.SearchResult.Cell.Text.Show}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.SearchResult.Cell.Text.Show
                                    }
                                }
                            ]
                        ]
                    }
                ],
                "page": {
                    "config": {
                        "block": {},
                        "layout": {}
                    },
                    "type": PageType.Content.SearchResultCell.Show,
                    "display": "Exhibition Search Result Cell Template",
                    "id": "pageSettings"
                }
            }
        };
    }
};

Defaults.Block[Name.Block.Show.List.Grid] = {
    Cell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "layout": {
                            "isCropped": true
                        }
                    },
                    "id": `${Name.Block.Show.Cell.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Show.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Show.Cell.Text].Title
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "id": `${Name.Block.Show.Cell.Text}-title-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Show.Cell.Text
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Show.Cell.Text].Date
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "10"
                            }
                        }
                    },
                    "id": `${Name.Block.Show.Cell.Text}-date-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Show.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.ExhibitionCell.Grid,
                "display": "Exhibition Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.Show.List.Parallax] = {
    Cell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "alignment-col1": "bl",
                            "columnCount": "1",
                            "flexDirection-col1": "column"
                        },
                        "layout": {
                            "minHeight": {
                                "unit": "%",
                                "value": "100"
                            },
                            "textAlign": "center"
                        }
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Columns
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "block": {
                                        "design": Layout.wrapTextForEditor({ tag: Kit.Context.Global.Header2, text: `{${Token.Title}}`, token: Token.Title })
                                    },
                                    "layout": {
                                        "marginBottom": {
                                            "unit": "px",
                                            "value": "10"
                                        },
                                        "marginTop": {
                                            "unit": "px",
                                            "value": "10"
                                        }
                                    }
                                },
                                "id": `${Name.Block.Show.Cell.Text}-title-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Show.Cell.Text
                                }
                            },
                            {
                                "config": {
                                    "block": {
                                        "design": Layout.wrapTextForEditor({ text: `{${Token.Date}("before":"","after":"")}`, token: Token.Date })
                                    },
                                    "layout": {
                                        "marginBottom": {
                                            "unit": "px",
                                            "value": "43"
                                        },
                                        "marginTop": {
                                            "unit": "px",
                                            "value": "7"
                                        }
                                    }
                                },
                                "id": `${Name.Block.Show.Cell.Text}-date-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Show.Cell.Text
                                }
                            },
                            {
                                "config": {
                                    "block": {
                                        "backgroundColor": "rgba(0,0,0,1)",
                                        "borderRadius": {
                                            "unit": "px",
                                            "value": ""
                                        },
                                        "design": Defaults.Block[Name.Block.ButtonV2]({ displayText: 'VIEW EXHIBITION', textColor: 'rgba(255,255,255,1)' })
                                    },
                                    "hover": {},
                                    "layout": {
                                        "alignment": "center",
                                        "marginBottom": {
                                            "unit": "px",
                                            "value": "17"
                                        },
                                        "paddingLeft": {
                                            "unit": "px",
                                            "value": "14"
                                        },
                                        "paddingRight": {
                                            "unit": "px",
                                            "value": "14"
                                        },
                                        "height": {
                                            "unit": "px",
                                            "value": "40"
                                        }
                                    }
                                },
                                "id": `${Name.Block.Show.Cell.DetailButtonV2}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Show.Cell.DetailButtonV2
                                }
                            }
                        ]
                    ]
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {
                        "paddingLeft": {
                            "unit": "px",
                            "value": "50"
                        },
                        "paddingBottom": {
                            "unit": "px",
                            "value": "50"
                        },
                        "paddingRight": {
                            "unit": "px",
                            "value": "50"
                        },
                        "paddingTop": {
                            "unit": "px",
                            "value": "50"
                        }
                    }
                },
                "type": PageType.Content.ExhibitionCell.Parallax,
                "display": "Exhibition Parallax Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.Show.List.Slideshow] = {
    Cell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "layout": {
                            "isCropped": true
                        }
                    },
                    "id": `${Name.Block.Show.Cell.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Show.Cell.Image
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Show.Cell.Text].Title
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "20"
                            }
                        }
                    },
                    "id": `${Name.Block.Show.Cell.Text}-title-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Show.Cell.Text
                    }
                },
                {
                    "config": {
                        "block": {
                            "design": Defaults.Block[Name.Block.Show.Cell.Text].Date
                        },
                        "layout": {
                            "marginTop": {
                                "unit": "px",
                                "value": "10"
                            }
                        }
                    },
                    "id": `${Name.Block.Show.Cell.Text}-date-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Show.Cell.Text
                    }
                }
            ],
            "page": {
                "config": {
                    "block": {},
                    "layout": {}
                },
                "type": PageType.Content.ExhibitionCell.Slideshow,
                "display": "Exhibition Slideshow Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.Artist.Show.List.Slideshow] = Defaults.Block[Name.Block.Show.List.Slideshow];

Defaults.Block[Name.Block.Show.List.SlideshowFullBackground] = {
    Cell: {
        "desktop": {
            "blocks": [
                {
                    "config": {
                        "block": {
                            "columnCount": "1",
                            "flexDirection-col1": "row",
                            "alignment-col1": "mc"
                        },
                        "layout": {
                            "minHeight": {
                                "unit": "vh",
                                "value": "100"
                            },
                            "textAlign": "center",
                            "backgroundPosition": "mc",
                            "backgroundSize": "contain",
                            "backgroundRepeatX": false,
                            "backgroundRepeatY": false
                        }
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Columns
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "block": {
                                        "design": `<p class="p"><span data-heading="p" token="${Token.Title}">{${Token.Title}}</span></p><p class="p"><span style="display:inline-block;margin:10px 0 0;" data-heading="p" token="${Token.Date}">{${Token.Date}("before":"","after":"")}</span></p>`
                                    },
                                    "layout": {}
                                },
                                "id": `${Name.Block.Show.Cell.Text}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Show.Cell.Text
                                }
                            }
                        ]
                    ]
                }
            ],
            "page": {
                "config": {
                    "block": {
                        "useBackgroundImage": true,
                        "backgroundPosition": "mc",
                        "backgroundRepeatX": false,
                        "backgroundRepeatY": false,
                        "backgroundSize": "cover"
                    },
                    "layout": {}
                },
                "type": PageType.Content.ExhibitionCell.Slideshow,
                "display": "Exhibition Slideshow Cell Template",
                "id": "pageSettings"
            }
        }
    }
};

Defaults.Block[Name.Block.Artist.Show.List.SlideshowFullBackground] = Defaults.Block[Name.Block.Show.List.SlideshowFullBackground];

Defaults.Block[Name.Block.Slider.Carousel] = {
    Cell: (imageId = 'kbn5xs7m9q78najh334g') => {
        return {
            "desktop": {
                "blocks": [
                    {
                        "config": {
                            "block": {
                                "columnCount": "1",
                                "flexDirection-col1": "row",
                                "alignment-col1": "bc"
                            },
                            "layout": {
                                "minHeight": {
                                    "unit": "%",
                                    "value": "100"
                                },
                                "textAlign": "center",
                                "backgroundImage": {
                                    "extension": "jpg",
                                    "id": imageId
                                },
                                "backgroundPosition": "bc",
                                "backgroundSize": "cover",
                                "backgroundRepeatX": false,
                                "backgroundRepeatY": false
                            }
                        },
                        "dataType": "layout",
                        "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                        "type": {
                            "value": Name.Block.Columns
                        },
                        "blocks": [
                            [
                                {
                                    "config": {
                                        "block": {
                                            "displayText": Layout.wrapTextForEditor({ text: 'Slider Example', textExtras: `style="color:rgba(255,255,255,1);font-size:20px;font-weight:bold;"` })
                                        },
                                        "container": {},
                                        "layout": {
                                            "paddingBottom": {
                                                "value": "40",
                                                "unit": "px"
                                            },
                                            "textAlign": "center"
                                        }
                                    },
                                    "id": `${Name.Block.Text}-${new Date().getTime()}`,
                                    "type": {
                                        "value": Name.Block.Text
                                    }
                                }
                            ]
                        ]
                    }
                ],
                "page": {
                    "config": {
                        "block": {},
                        "layout": {}
                    },
                    "type": PageType.Content.Slide,
                    "display": "Slide Content",
                    "id": "pageSettings"
                }
            }
        }
    }
};

Defaults.Block[Name.Block.SubscribeForm.Container] = Defaults.subscribeForm(PageType.Form.Subscribe);

export default Defaults;
